import React, { Component } from "react";
import { calculatePrice } from "../../pricing/calculatePrice";
import Axios from "axios";
import { connect } from "react-redux";
import { configuration } from "../../appConfig";
import Swal from "sweetalert2";
import verticle from './vertical.json'
import horizontal from './horizontal.json'
import PriceCZ from './PricesCZ.json'
import "./DNSPriceTable.css";
import Lightbox from "react-image-lightbox";
import { getSelectedPartnerId } from "../../redux/actions/duplicateVinPartnerId";
const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class CZPriceTable extends Component {
    state = {
        words: {},
        lang: "En",
        data: [],
        Dents: [],
        ALUPercentage: "",
        LAKPercentage: "",
        softwareType: "",
        loadedFirstTime: true,
        loadedFirstTimeAVG: true,
        preparation: '',
        dismantling: '',
        PricePerHour: '',
        ShowPrice: false,
        insuranceName: "",
        imageArr: [],
        imageArrDamage: [],
        currentImageIndex: 0,
        filteredImages: [],
        insuaranceProvider: {}
    };
    count = [];
    calPrice = (average, count) => {
        let pp = calculatePrice(average, count);
        //this.count.push(pp)
        return (pp * 130) / 6;
    };
    calUnit = (average, count) => {
        let pp = calculatePrice(average, count);
        this.count.push(pp);
        return pp;
    };
    avg = (No) => {
        let round = Math.round(No / 10);
        return round * 10;
    };

    getJsonApi = () => {
        const partnerId = localStorage.getItem("partnerId");
        const vin = localStorage.getItem("selectedFile");
        Axios.get(
            `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
        ).then((r) => {
            if (r.data) {
                this.setState({
                    softwareType: r.data.SoftwareType,
                    dismantling: r.data.Dismantling || 25,
                    preparation: r.data.Preparation || 10,
                    ShowPrice: r.data.ShowPrice,
                    insuranceName: this.state.insuranceName === '' ? (r.data.InsurenceName || "") : this.state.insuranceName
                })
                const arrDataAE = [
                    //1
                    [
                        "Dämmung",
                        "Gitter",
                        "Komplett"
                    ],
                    //2
                    [
                        "Scheinwerfer",
                        "Radhaus",
                        "Komplett"
                    ],
                    //3
                    [
                        "Komplett",
                        "Schachtleiste",
                        "Verkleidung",
                        "Spiegel",
                        "Griff"
                    ],
                    //4
                    [
                        "Komplett",
                        "Schachtleiste",
                        "Verkleidung",
                        "Griff"
                    ],
                    //5
                    [
                        "Rücklicht",
                        "Verkleidung",
                        "Radhausschale",
                        "TankEinsatz",
                    ],
                    //6
                    [
                        "3. Bremsleucht",
                        "Heckklappe",
                        "Verkleidung"
                    ],
                    //7
                    [
                        "3. Bremsleucht",
                        "Heckklappe",
                        "Verkleidung"
                    ],
                    //8
                    [
                        "Rücklicht",
                        "Verkleidung",
                        "Radhausschale",
                        "TankEinsatz"
                    ],
                    //9
                    [
                        "Komplett",
                        "Schachtleiste",
                        "Verkleidung",
                        "Griff"
                    ],
                    //10
                    [
                        "Schachtleiste",
                        "Verkleidung",
                        "Spiegel",
                        "Komplett",
                        "Griff"
                    ],
                    //11
                    [
                        "Schachtleiste",
                        "Radhaus",
                        "Komplett"
                    ],
                    //12
                    [
                        "Dämmung",
                        "Himmel",
                        "Panorama",
                        "Dachantenne"
                    ],
                    //13
                    [
                        "Dachreling"
                    ],
                    //14
                    [
                        "Dachreling"
                    ],
                    // ["Rucklicht", "Verkleidung", "Radhausschale", "Tank Einsatz"],
                    // ["Rucklicht", "Verkleidung", "Radhausschale", "Tank Einsatz"],
                    // ["Frontscheibe", "Rahmen", "StoBstange"],

                ];
                r.data.Dents && r.data.Dents.map((dent, index) => {
                    dent.arrAE = arrDataAE[index];
                });

                const arrDataErsetzenErsetzen = [
                    //1
                    [
                        "Befestigungssatz",
                        "Embleme",
                        "Motorhaube"
                    ],
                    //2
                    [
                        "Befestigungssatz",
                        "Blinker",
                        "Kotflügel "
                    ],
                    //3
                    [
                        "Tür",
                        "Zierleiste:",
                        "Befestigungssatz",
                        "Spiegel",
                        "Schachtleiste",
                        "Blende:",
                        "Türfolie",
                    ],
                    //4
                    [
                        "Tür",
                        "Zierleiste:",
                        "Befestigungssatz",
                        "Schachtleiste",
                        "Blende:",
                        "Türfolie",
                    ],
                    //5
                    [
                        "Rückleuchte",
                        "Seitenscheibe",
                        "Zierleiste Scheibe",
                    ],
                    //6
                    [
                        "3.Bremsleuchte",
                        "Heckklappe",
                        "Leuchte IL ",
                        "Leuchte IR",
                        "Befestigungssatz",
                        "Embleme",
                    ],
                    //7
                    [
                        "3.Bremsleuchte",
                        "Heckklappe",
                        "Leuchte IL ",
                        "Leuchte IR",
                        "Befestigungssatz",
                        "Embleme",
                    ],
                    //8
                    [
                        "Rückleuchte",
                        "Seitenscheibe",
                        "Zierleiste Scheibe"
                    ],
                    //9
                    [
                        "Tür",
                        "Zierleiste:",
                        "Befestigungssatz",
                        "Schachtleiste",
                        "Blende:",
                        "Türfolie",
                    ],
                    //10
                    [
                        "Tür",
                        "Türfolie",
                        "Spiegel",
                        "Zierleiste:",
                        "Schachtleiste",
                        "Befestigungssatz",
                        "Blende:"
                    ],
                    //11
                    [
                        "Befestigungssatz",
                        "Blinker",
                        "Kotflügel"
                    ],
                    //12
                    [
                        "Himmel",
                        "Dämmung x 0",
                        "Dachantenne",
                        "Handgriff x 0"
                    ],
                    //13
                    [
                        "Kap. Reling x 0",
                        "Dachleiste"
                    ],
                    //14
                    [
                        "Kap. Reling x 0",
                        "Dachleiste"
                    ],
                    // [
                    //   "Heckscheibe",
                    //   "Wischerkappe",
                    //   "Tankdeckel",
                    //   "Spolier",
                    //   "StoBstange",
                    // ],
                ];
                r.data.Dents && r.data.Dents.map((dent, index) => {
                    dent.arrErsetzen = arrDataErsetzenErsetzen[index];
                    // this.getAW(dent)
                });
                if (r.data.Client != "") {
                    this.getInsurenceClients()
                }
                this.getFallbackDetails();
                this.setState({ data: r.data, Dents: r.data.Dents, Client: r.data.Client });
            }
        });
    };

    getInsurenceClients = async () => {
        const partnerId = localStorage.getItem("partnerId");

        if (partnerId) {
            const url = configuration.getInsurenceClients + "?partnerId=" + partnerId;
            const response = await Axios.post(url)
            if (response.data) {
                response.data.map((info) => {
                    if (this.state.Client && this.state.Client != undefined && this.state.Client != "" && this.state.Client.toLocaleLowerCase() && this.state.Client.toLocaleLowerCase() == info.Name.toLocaleLowerCase()) {
                        this.setState({ insuaranceProvider: info })
                    }
                })
            }
        }
    };

    async componentDidMount() {
        this.getJsonApi();
        this.getLang();
        // this.getFallbackDetails();
        this.getScanImages()
        await this.getInsuranceName();
    }

    getScanImages = async () => {
        const partnerId = localStorage.getItem("partnerId");
        const selectedFile = localStorage.getItem("selectedFile");
        try {
            const response = await Axios.get(configuration.getScanImages, {
                params: {
                    partnerId: partnerId,
                    vin: selectedFile,
                },
            });

            if (response && response.data) {
                const { data } = response;
                const filterImages = (images, keyword) => {
                    return images ? images.filter(image => image.includes(keyword)) : [];
                };

                const Left = [
                    ...filterImages(data.LeftFrontFender || data.Left, "LeftFrontFender"),
                    ...filterImages(data.LeftFrontDoor || data.Left, "LeftFrontDoor"),
                    ...filterImages(data.LeftBackDoor || data.Left, "LeftBackDoor"),
                    ...filterImages(data.LeftBackFender || data.Left, "LeftBackFender")
                ];

                const right = [
                    ...filterImages(data.RightFrontFender || data.right, "RightFrontFender"),
                    ...filterImages(data.RightFrontDoor || data.right, "RightFrontDoor"),
                    ...filterImages(data.RightBackDoor || data.right, "RightBackDoor"),
                    ...filterImages(data.RightBackFender || data.right, "RightBackFender")
                ];

                this.setState({
                    imageArr: [
                        ...data.Hood,
                        ...data.Roof,
                        ...data.RightRoofFrame,
                        ...data.LeftRoofFrame,
                        ...data.TrunkCover,
                        ...data.Trunk,
                        ...right,
                        ...Left,
                    ],
                });

                const LeftDamage = [
                    ...filterImages(data.LeftFrontFender_damage, "LeftFrontFender"),
                    ...filterImages(data.LeftFrontDoor_damage, "LeftFrontDoor"),
                    ...filterImages(data.LeftBackDoor_damage, "LeftBackDoor"),
                    ...filterImages(data.LeftBackFender_damage, "LeftBackFender")
                ];

                const rightDamage = [
                    ...filterImages(data.RightFrontFender_damage, "RightFrontFender"),
                    ...filterImages(data.RightFrontDoor_damage, "RightFrontDoor"),
                    ...filterImages(data.RightBackDoor_damage, "RightBackDoor"),
                    ...filterImages(data.RightBackFender_damage, "RightBackFender")
                ];

                this.setState({
                    imageArrDamage: [
                        ...data.Hood_damage,
                        ...data.Roof_damage,
                        ...data.RightRoofFrame_damage,
                        ...data.LeftRoofFrame_damage,
                        ...data.TrunkCover_damage,
                        ...data.Trunk_damage,
                        ...rightDamage,
                        ...LeftDamage,


                    ],
                });
            }
        } catch (error) {
            console.error("Error fetching scan images:", error);
        }
    };

    getInsuranceName = () => {
        let partnerId = localStorage.getItem("partnerId")
        let vin = localStorage.getItem("selectedFile").split("_")[0];
        let url = configuration.getSingleQRDetails + "?partnerId=" + partnerId + "&vin=" + vin + "&qr_type=" + 1
        Axios.get(url)
            .then((res) => {
                if (res.data.data.length && res.data.data[0].InsurenceName) {
                    this.setState({
                        insuranceName: res.data.data[0].InsurenceName
                    })
                }
            })
            .catch((err) => {
            })
    }
    getFallbackDetails = async () => {
        const url =
            configuration.getFallbackDetails +
            `?partner_id=${localStorage.getItem("partnerId")}`;
        const res = await Axios.get(url);

        function hexToRgb(hex) {
            hex = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b);
            let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        }

        let rgbColor = hexToRgb(this.state.insuaranceProvider.PrimaryColor || res.data.primary_color);
        let rgbaColor = `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.20)`;

        if (res.data.success !== false) {
            this.props.getSelectedPartnerId({
                duplicateSelectedPartnerId: res.data.vin_duplicate_partner_id.length > 0 ? res.data.vin_duplicate_partner_id : [],
                isDuplicateVin: res.data.is_vin_duplicate
            })
            this.setState({
                ALUPercentage: res.data.alu,
                LAKPercentage: res.data.lak,
                PrimaryColor: res.data.primary_color || "#FF0000",
                SecondaryColor: res.data.secondary_color || "#000000",
                PrimaryTextColor: res.data.primary_text_color || "#000000",
                SecondaryTextColor: res.data.secondary_text_color || "#fff",
                rgbaColor: rgbaColor,
            });
        }
    };

    getLang = () => {
        const base_url = window.location.origin;
        Axios.get(`${base_url}/lang.json`).then((res) => {
            this.setState({ words: res.data, lang: localStorage.getItem("lang") });
        });
    };
    lang = (word) => {
        const { lang, words } = this.state;

        return words[word] ? words[word][lang] : word;
    };
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.lang !== prevState.lang) {
            return { lang: nextProps.lang };
        } else return null;
    }
    saveChanges = (payload) => {
        const { data } = this.state;
        const totalDents = this.getTotalDents();
        payload["TotalDentCount"] = totalDents;
        payload['ShowPrice'] = this.state.ShowPrice
        payload.IsPriceTableUpdated = true;
        const url =
            configuration.PostEditorChanges +
            `?partnerId=${localStorage.getItem(
                "partnerId"
            )}&vin=${localStorage.getItem("selectedFile")}&dents=${totalDents}&TabViewUpdated=${!data.TabViewUpdated}`;

        Axios.post(url, payload).then((res) => {
            Toast.fire({
                type: "success",
                title: "Data updated",
            });
            // window.location.reload();
        });
    };

    changeAE = (event, index, value, key) => {
        const { Dents, data, tab } = this.state;
        const totalDents = Dents[index].TotalDents;
        const aeArr = Array.isArray(Dents[index]["AE"]) ? Dents[index]["AE"] : [];

        if (event.target.checked) {
            // if (key === "AE") {
            aeArr.push(`${value}`);
            // Dents[index]["AE"] = [];
            // }
        } else {
            aeArr.map((val, idx) => {
                if (value == val) {
                    aeArr.splice(idx, 1);
                }
            });
        }

        Dents[index]["AE"] = aeArr;
        // Dents[index]["AE"] = [];
        this.setState({ data });
        // this.saveChanges(data, totalDents);
    };

    changeErsetzen = (event, index, value, key) => {
        const { Dents, data } = this.state;
        const totalDents = Dents[index].TotalDents;
        const ersetzenArr = Array.isArray(Dents[index]["Ersetzen"])
            ? Dents[index]["Ersetzen"]
            : [];

        if (event.target.checked) {
            // if (key === "Ersetzen") {
            ersetzenArr.push(`${value}`);
            // Dents[index]["Ersetzen"] = [];
            // }
        } else {
            ersetzenArr.map((val, indx) => {
                if (value == val) {
                    ersetzenArr.splice(indx, 1);
                }
            });
        }

        Dents[index]["Ersetzen"] = ersetzenArr;
        // Dents[index]["Ersetzen"] = [];
        this.setState({ data });
        // this.saveChanges(data, totalDents);
    };

    decimalAdjust = (type, value, exp) => {
        // If the exp is undefined or zero...
        if (typeof exp === 'undefined' || +exp === 0) {
            return Math[type](value);
        }
        value = +value;
        exp = +exp;
        // If the value is not a number or the exp is not an integer...
        if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
            return NaN;
        }
        // Shift
        value = value.toString().split('e');
        value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
        // Shift back
        value = value.toString().split('e');
        return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
    }

    round10 = (value, exp) => this.decimalAdjust('round', value, exp);


    plasticChange = (part, e, index, key) => {
        const { name } = e.target;
        const { Dents, data } = this.state;
        if (e.target.checked) {
            data["Dents"][index]["B"] = 0
            data["Dents"][index]["TotalDents"] = 0
        } else {
            data["Dents"][index]["B"] = data["Dents"][index]["AvgDiaMm"]
            data["Dents"][index]["TotalDents"] = data["Dents"][index]["A"]
        }
        data["Dents"][index][key] = e.target.checked;
        this.setState({ data }, () => {
            // this.handleSave()
        });
    };

    change = (part, e, index, key) => {
        const { Dents, data } = this.state;
        const totalDents = Dents[index].TotalDents;

        // if(Dents[index]['AW']){

        // if(key === 'Replace'){
        //   Dents[index]['Alu'] = false;
        //   Dents[index]['Push2paint'] = false;
        //   Dents[index][key] = e.target.checked;
        // }
        // else{
        // if(Dents[index]['Replace']){
        //   Dents[index]['Replace'] = false;
        //   Dents[index]['AW'] = Dents[index]['AW_original'] || 0;
        // }

        // }

        // }
        // else{
        //   Dents[index][key] = e.target.checked;
        //   if(key === 'Replace'){
        //     Dents[index]['Alu'] = false;
        //     Dents[index]['Push2paint'] = false;
        //     Dents[index][key] = e.target.checked;
        //     Dents[index]['AW'] = 0;
        //   }
        //   else{
        //     if(Dents[index]['Replace']){
        //       Dents[index]['Replace'] = false;
        //     }
        //   }
        // }
        // if (key === "AE") {
        //   if (!Dents[index][key]) {
        //     Dents[index]["AE"] = Dents[index]["Hello"];
        //   }
        // }
        var indexOfTrunkCover = Dents.findIndex((dentPart) => {
            return dentPart.Part == "TrunkCover";
        });
        if (key === "Replace") {
            if (Dents[index][key] && !Dents[index]["Plastic"]) {
                Dents[index]["TotalDents"] = Dents[index]["OriginalDents"] || 0;
                Dents[index]["A"] = Dents[index]["OriginalDents"] || 0
                Dents[index]["B"] = Dents[index]['AvgDiaMm'] || 0
                if (part === "Trunk") {
                    Dents[indexOfTrunkCover]["TotalDents"] = Dents[indexOfTrunkCover]["OriginalDents"] || 0;
                    Dents[indexOfTrunkCover]["A"] = Dents[indexOfTrunkCover]["OriginalDents"] || 0
                    Dents[indexOfTrunkCover]["B"] = Dents[indexOfTrunkCover]['AvgDiaMm'] || 0
                }

            } else {
                Dents[index]["Alu"] = false;
                Dents[index]["Push2paint"] = false;
                Dents[index]["Glue"] = false;
                Dents[index]["TotalDents"] = 0;
                Dents[index]["A"] = 0;
                Dents[index]["B"] = 0
                if (part === "Trunk") {
                    Dents[indexOfTrunkCover]["Alu"] = false;
                    Dents[indexOfTrunkCover]["Push2paint"] = false;
                    Dents[indexOfTrunkCover]["Glue"] = false;
                    Dents[indexOfTrunkCover]["TotalDents"] = 0;
                    Dents[indexOfTrunkCover]["A"] = 0;
                    Dents[indexOfTrunkCover]["B"] = 0
                }
            }
        } else if (key === "Plastic") {
            if (Dents[index][key] && !Dents[index]["Replace"]) {
                Dents[index]["TotalDents"] = Dents[index]["OriginalDents"] || 0;
                Dents[index]["A"] = Dents[index]["OriginalDents"] || 0
                Dents[index]["B"] = Dents[index]['AvgDiaMm'] || 0
                if (part === "Trunk") {
                    Dents[indexOfTrunkCover]["TotalDents"] = Dents[indexOfTrunkCover]["OriginalDents"] || 0;
                    Dents[indexOfTrunkCover]["A"] = Dents[indexOfTrunkCover]["OriginalDents"] || 0
                    Dents[indexOfTrunkCover]["B"] = Dents[indexOfTrunkCover]['AvgDiaMm'] || 0
                }
            } else {
                Dents[index]["Alu"] = false;
                Dents[index]["Push2paint"] = false;
                Dents[index]["TotalDents"] = 0;
                Dents[index]["A"] = 0;
                Dents[index]["B"] = 0
                if (part === "Trunk") {
                    Dents[indexOfTrunkCover]["Alu"] = false;
                    Dents[indexOfTrunkCover]["Push2paint"] = false;
                    Dents[indexOfTrunkCover]["TotalDents"] = 0;
                    Dents[indexOfTrunkCover]["A"] = 0;
                    Dents[indexOfTrunkCover]["B"] = 0
                }
            }
        }
        else {
            if (Dents[index]["Replace"] || Dents[index]["Plastic"]) {
                Dents[index]["Replace"] = false;
                Dents[index]["Plastic"] = false;
                Dents[index]["TotalDents"] = Dents[index]["OriginalDents"] || 0;
                Dents[index]["A"] = Dents[index]["OriginalDents"] || 0
                Dents[index]["B"] = Dents[index]['AvgDiaMm'] || 0
            }

            const { ALUPercentage, LAKPercentage } = this.state;

            let aluPr = parseFloat(ALUPercentage);
            let lakPr = parseFloat(LAKPercentage)

            if (!Dents[index][key]) {
                let incPR = 0;
                if (key === "Alu" && this.state.ALUPercentage) {


                    //inc by both if both are true
                    if (Dents[index]["Push2paint"]) {
                        incPR = aluPr + lakPr;
                    }
                    else {
                        incPR = aluPr;
                    }

                } else if (key === "Push2paint" && this.state.LAKPercentage) {


                    // inc by both% if both are trye

                    if (Dents[index]["Alu"]) {
                        incPR = aluPr + lakPr;
                    }

                    else {
                        incPR = lakPr;
                    }
                }

                if (Dents[index]["OriginalAw"]) {
                    if (localStorage.getItem('partnerId') === "1-190301") {

                        Dents[index]["AW"] = 0 || Math.ceil(
                            parseFloat(Dents[index]["OriginalAw"]) +
                            (parseFloat(Dents[index]["OriginalAw"]) * incPR) /
                            100.0
                        );
                    }
                } else {
                    if (localStorage.getItem('partnerId') === "1-190301") {
                        Dents[index]["AW"] = 0 || Math.ceil(
                            parseFloat(Dents[index]["AW"]) +
                            (parseFloat(Dents[index]["AW"]) * incPR) /
                            100.0
                        );
                    }
                }

            } else {
                // while unchecking
                let incPR = 0;
                if (key === "Alu" && this.state.ALUPercentage) {
                    //set to originalAw when both unchecked

                    if (!Dents[index]["Push2paint"]) {
                        if (localStorage.getItem('partnerId') === "1-190301") {
                            Dents[index]['AW'] = Dents[index]["OriginalAw"] || Math.floor(
                                parseFloat(Dents[index]["AW"]) -
                                (parseFloat(Dents[index]["AW"]) * this.state.ALUPercentage) /
                                100.0
                            );
                        }
                    } else {
                        incPR = lakPr;
                    }
                } else if (key === "Push2paint" && this.state.LAKPercentage) {
                    //set to originalAw when both umchecked
                    if (!Dents[index]["Alu"]) {
                        if (localStorage.getItem('partnerId') === "1-190301") {
                            Dents[index]['AW'] = Dents[index]["OriginalAw"] || Math.floor(
                                parseFloat(Dents[index]["AW"]) -
                                (parseFloat(Dents[index]["AW"]) * this.state.LAKPercentage) /
                                100.0
                            );
                        }

                    } else {

                        incPR = aluPr;

                    }
                }

                if (Dents[index]["OriginalAw"]) {
                    if (localStorage.getItem('partnerId') === "1-190301") {
                        Dents[index]["AW"] = 0 || Math.ceil(
                            parseFloat(Dents[index]["OriginalAw"]) +
                            (parseFloat(Dents[index]["OriginalAw"]) * incPR) /
                            100.0
                        );
                    }
                } else {
                    if (localStorage.getItem('partnerId') === "1-190301") {

                        Dents[index]['AW'] = Math.floor(
                            parseFloat(Dents[index]["AW"]) -
                            (parseFloat(Dents[index]["AW"]) * incPR) /
                            100.0
                        );
                    }
                }
                // Dents[index]['AW'] = (parseFloat(parseFloat(Dents[index]['AW'])) - parseFloat((parseFloat(Dents[index]['AW'])/10.00))).toFixed(2);
            }
        }
        Dents[index][key] = e.target.checked;

        this.setState({ data });
        // this.saveChanges(data, totalDents);
    };
    totalDamages = (arr) => {
        let total = 0;
        arr.forEach(el => {
            if (el.TotalDamages) {
                total = total + el.TotalDamages
            }
        })
        return total;
    }
    getTotalDents = () => {
        const { Dents } = this.state;
        let totalDents = Dents &&
            Dents.reduce(
                (acc, num) =>
                    parseInt(acc) + parseInt(num.TotalDents),
                0
            )
        return totalDents
    }
    handleChange = (part, index, e, key) => {

        const { Dents, data } = this.state;
        const { name, value } = e.target;
        if (key === 'loadedFirstTimeAVG') {
            this.setState({
                loadedFirstTimeAVG: false
            })
        }
        if (name === 'TotalDents') {
            this.setState({
                loadedFirstTime: false,
            });
            if (part == 'Trunk') {
                var indexOfTrunkCover = Dents.findIndex((dentPart) => {
                    return dentPart.Part == "TrunkCover";
                });
                if (indexOfTrunkCover >= 0) {
                    Dents[index][name] = Math.abs(value ? parseInt(value) : 0) + (Dents[indexOfTrunkCover]['A'] ? parseInt(Dents[indexOfTrunkCover]['A']) : 0);
                    Dents[index]["A"] = Math.abs(value ? parseInt(value) : 0) + (Dents[indexOfTrunkCover]['A'] ? parseInt(Dents[indexOfTrunkCover]['A']) : 0);
                    Dents[indexOfTrunkCover]['A'] = 0;
                    Dents[indexOfTrunkCover][name] = 0;
                }
            }
            else {
                Dents[index][name] = Math.abs(value ? parseInt(value) : 0);
                Dents[index]["A"] = Math.abs(value ? parseInt(value) : 0);
            }

            let filtered;
            let maxVerticle;
            let maxHorizontal;
            if (part == "Hood" || part == "TrunkCover" || part == "Roof") {
                if (Dents[index]["A"] > 50) {
                    // filtered[0] = verticle[verticle.length - 1]
                    maxVerticle = true;
                } else {
                    maxVerticle = false;
                    filtered = verticle.filter((item) => {
                        return item.A === Dents[index]["A"]
                    })
                }
            } else {
                if (Dents[index]["A"] > 250) {
                    maxHorizontal = true;
                    // filtered[0] = verticle[verticle.length - 1]
                } else {
                    maxHorizontal = false;
                    filtered = horizontal.filter((item) => {
                        return item.A === Dents[index]["A"]
                    })
                    if (!filtered.length) {
                        filtered[0] = horizontal.reduce((prev, curr) => {
                            return (Math.abs(curr.A - Dents[index]["A"])) < (Math.abs(prev.A - Dents[index]["A"])) ? curr : prev
                        })
                    }
                }
            }

            if (localStorage.getItem('partnerId') === "1-190301") {
                if (maxVerticle) {
                    Dents[index]['AW'] = verticle[verticle.length - 1][`B${Dents[index]['AvgDiaMm']}`] ? verticle[verticle.length - 1][`B${Dents[index]['AvgDiaMm']}`] : 0
                } else if (maxHorizontal) {
                    Dents[index]['AW'] = horizontal[horizontal.length - 1][`B${Dents[index]['AvgDiaMm']}`] ? horizontal[horizontal.length - 1][`B${Dents[index]['AvgDiaMm']}`] : 0
                } else {
                    Dents[index]['AW'] = filtered[0][`B${Dents[index]['AvgDiaMm']}`] ? filtered[0][`B${Dents[index]['AvgDiaMm']}`] : 0
                }
            }

            const deviation = value - Dents[index]['OriginalDents'];
            if (deviation > 0) {
                Dents[index]['AddedCount'] = deviation;
                Dents[index]['RemovedCount'] = 0;
            } else {
                Dents[index]['RemovedCount'] = Math.abs(deviation);
                Dents[index]['AddedCount'] = 0;
            }
        } else if (name === 'B') {
            Dents[index]["AvgDiaMm"] = (value ? parseInt(value) : 0);
            Dents[index]["B"] = (value ? parseInt(value) : 0);

            let filtered;
            let maxVerticle;
            let maxHorizontal;

            if (part == "Hood" || part == "TrunkCover" || part == "Roof") {
                if (Dents[index]["A"] > 50) {
                    // filtered[0] = verticle[verticle.length - 1]
                    maxVerticle = true;
                } else {
                    maxVerticle = false;
                    filtered = verticle.filter((item) => {
                        return item.A === Dents[index]["A"]
                    })
                }
            } else {
                if (Dents[index]["A"] > 250) {
                    maxHorizontal = true;
                } else {
                    maxHorizontal = false;
                    filtered = horizontal.filter((item) => {
                        return item.A === Dents[index]["A"]
                    })
                    if (!filtered.length) {
                        filtered[0] = horizontal.reduce((prev, curr) => {
                            return (Math.abs(curr.A - Dents[index]["A"])) < (Math.abs(prev.A - Dents[index]["A"])) ? curr : prev
                        })
                    }
                }
            }
            if (localStorage.getItem('partnerId') === "1-190301") {
                if (maxVerticle) {
                    Dents[index]['AW'] = verticle[verticle.length - 1][`B${Dents[index]['AvgDiaMm']}`] ? verticle[verticle.length - 1][`B${Dents[index]['AvgDiaMm']}`] : 0
                } else if (maxHorizontal) {
                    Dents[index]['AW'] = horizontal[horizontal.length - 1][`B${Dents[index]['AvgDiaMm']}`] ? horizontal[horizontal.length - 1][`B${Dents[index]['AvgDiaMm']}`] : 0
                } else {
                    Dents[index]['AW'] = filtered[0][`B${Dents[index]['AvgDiaMm']}`] ? filtered[0][`B${Dents[index]['AvgDiaMm']}`] : 0
                }
            }
        } else if (name === 'AW') {
            if (localStorage.getItem('partnerId') === "1-190301") {

                Dents[index]["AW"] = (value ? parseInt(value) : 0);
                Dents[index]["C"] = (value ? parseInt(value) : 0);
            }
        }


        // Dents[index]["A"] = ( value ? parseInt(value) : 0 );
        // const deviation = value - Dents[index]['OriginalDents'];

        // if ( deviation > 0 ) {
        //   Dents[index]['AddedCount'] = deviation;
        //   Dents[index]['RemovedCount'] = 0;
        // } else {
        //   Dents[index]['RemovedCount'] = Math.abs(deviation);
        //   Dents[index]['AddedCount'] = 0;

        // }

        // if (Dents[index]["TotalDents"] > 250) {
        //   Dents[index]["Replace"] = true;
        // } else {
        //   Dents[index]["Replace"] = false;
        // }

        // data[index]["TotalDents"] = data[index]["A"] + data[index]["B"];
        this.getAW(Dents[index], index)
        this.setState({ data });
    }
    getAW = (row, index) => {
        // let insuranceName = localStorage.getItem('InsurenceName') 
        const { insuranceName } = this.state

        if (insuranceName === 'Axa' || insuranceName === "Slavia" || insuranceName === "Direct") {
            return row.Plastic ? "0.00" : this.getAxaAW(row, index)
        } else if (insuranceName === 'Audatex') {
            return row.Plastic ? "0.00" : this.getAudataxAW(row, index)
        } else if (insuranceName === 'Allianz') {
            return row.Plastic ? "0.00" : this.getAllianzAW(row, index)
        } else {
            // For other Insurance Client
            return row.Plastic ? "0.00" : "0.00";
        }
    }
    handleFooterChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    updateTrunkValue = (row, index) => {
        const { Dents } = this.state
        var indexOfTrunkCover = Dents && Dents.findIndex((dentPart) => {
            return dentPart.Part == "TrunkCover";
        });
        Dents[index]["A"] = Dents[index]["A"] + Dents[indexOfTrunkCover]["A"]
        Dents[index]["TotalDents"] = Dents[index]["TotalDents"] + Dents[indexOfTrunkCover]['TotalDents']
        Dents[index]["AvgDiaMm"] = Dents[index]["AvgDiaMm"] + Dents[indexOfTrunkCover]['AvgDiaMm']
        Dents[indexOfTrunkCover]['A'] = 0;
        Dents[indexOfTrunkCover]['TotalDents'] = 0
        Dents[indexOfTrunkCover]['AvgDiaMm'] = 0
    }
    getAxaAW = (row, index) => {
        if (row.Part === 'Trunk') {
            this.updateTrunkValue(row, index)
        }
        let partArr = [];
        let filterSizeArr = [];
        const { ALUPercentage, LAKPercentage } = this.state;
        let price, incPR, finalPrice
        if (row.Part === 'Hood' || row.Part === 'Roof') {
            partArr = PriceCZ.AXA.roof
        } else if (row.Part === 'LeftFrontFender' || row.Part === 'LeftFrontDoor' || row.Part === 'LeftBackDoor' || row.Part === 'LeftBackFender' || row.Part === 'RightBackFender' || row.Part === 'RightBackDoor' || row.Part === 'RightFrontDoor' || row.Part === 'RightFrontFender') {
            partArr = PriceCZ.AXA.fender
        } else if (row.Part === 'Trunk' || row.Part === 'TrunkCover' || row.Part === 'RightRoofFrame' || row.Part === "LeftRoofFrame") {
            partArr = PriceCZ.AXA.trunk
        }

        // for filter total dents
        partArr.length && partArr.forEach((val) => {
            if (row.TotalDents === 0) {
                price = 0;
            } else {
                if (val.dents.min <= row.TotalDents && val.dents.max >= row.TotalDents) {
                    filterSizeArr.push(val.sizes)
                }
            }
        })

        // for sizes
        filterSizeArr && filterSizeArr[0] && filterSizeArr[0].length && filterSizeArr[0].forEach((sizes) => {
            if (sizes.size === row.AvgDiaMm) {
                price = sizes.value
            } else if (row.AvgDiaMm > 40 && sizes.size === 40) {
                price = sizes.value
            } else if (row.AvgDiaMm < 20 && sizes.size === 20) {
                price = sizes.value
            }
        })
        let aluPr = parseFloat(ALUPercentage);
        let lakPr = parseFloat(LAKPercentage);
        if (row.Alu && row.Push2paint) {
            //if Alu and lak both are enabled
            incPR = aluPr + lakPr;
        } else if (row.Alu) {
            //if only Alu is enabled
            incPR = aluPr;
        } else if (row.Push2paint) {
            //if only Push2paint is enabled
            incPR = lakPr;
        } else {
            //if only Push2paint is enabled
            incPR = 0;
        }
        if (incPR !== 0) {
            finalPrice = 0 || (
                parseFloat(price) +
                (parseFloat(price) * incPR) /
                100.0
            );
        } else {
            finalPrice = price;
        }
        finalPrice = Intl.NumberFormat('en-IN', { currency: 'CZK', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(finalPrice) // for 8,909.00
        return finalPrice
    }
    getAudataxAW = (row, index) => {
        if (row.Part === 'Trunk') {
            this.updateTrunkValue(row, index)
        }
        let isHorizontalParts;
        let partArr = [];
        let filterSizeArr = [];
        const { ALUPercentage, LAKPercentage } = this.state;
        let originalAW, incPR, finalAW
        const horizontalParts = ['Hood', 'Trunk', "TrunkCover", "Roof", "LeftRoofFrame", "RightRoofFrame"];
        const verticalParts = ["LeftFrontFender", "LeftBackFender", "LeftFrontDoor", "LeftBackDoor", "RightBackFender", "RightFrontFender", "RightBackDoor", "RightFrontDoor"];
        if (horizontalParts.includes(row.Part)) {
            partArr = PriceCZ.AUDATEX.horizontal;
            isHorizontalParts = true
        } else if (verticalParts.includes(row.Part)) {
            partArr = PriceCZ.AUDATEX.Vertical;
            isHorizontalParts = false
        }
        partArr.length && partArr.forEach((val) => {
            if (row.TotalDents === 0) {
                originalAW = 0;
            } else if (isHorizontalParts && row.TotalDents > 250 && val.dents === 250) {
                filterSizeArr.push(val.sizes)
            } else if (isHorizontalParts === false && row.TotalDents > 50 && val.dents === 50) {
                filterSizeArr.push(val.sizes)
            } else {
                if (val.dents === row.TotalDents) {
                    filterSizeArr.push(val.sizes)
                }
            }
        })
        filterSizeArr && filterSizeArr[0] && filterSizeArr[0].length && filterSizeArr[0].forEach((sizes) => {
            if (sizes.size === row.AvgDiaMm) {
                originalAW = sizes.value;
            } else if (row.AvgDiaMm > 80 && sizes.size === 80) {
                originalAW = sizes.value;
            } else if (row.AvgDiaMm < 10 && sizes.size === 10) {
                originalAW = sizes.value
            }
            // if totalDents is more than 250 => get AW of dent 250 and add (totaDent - 250)*0.41AE 
        })
        if (row.TotalDents > 250) {
            originalAW += parseFloat((row.TotalDents - 250) * 0.41)
        }
        let aluPr = parseFloat(ALUPercentage);
        let lakPr = parseFloat(LAKPercentage);
        if (row.Alu && row.Push2paint) {
            //if Alu and lak both are enabled
            incPR = aluPr + lakPr;
        } else if (row.Alu) {
            //if only Alu is enabled
            incPR = aluPr;
        } else if (row.Push2paint) {
            //if only Push2paint is enabled
            incPR = lakPr;
        } else {
            //if only Push2paint is enabled
            incPR = 0;
        }
        if (incPR !== 0) {
            finalAW = 0 || (
                parseFloat(originalAW) +
                (parseFloat(originalAW) * incPR) /
                100.0
            );
        } else {
            finalAW = originalAW;
        }
        finalAW = Intl.NumberFormat('en-IN', { currency: 'CZK', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(finalAW) // for 8,909.00
        return finalAW
    }
    getAllianzAW = (row, index) => {
        if (row.Part === 'Trunk') {
            this.updateTrunkValue(row, index)
        }
        let partArr = [];
        let filterSizeArr = [];
        const { ALUPercentage, LAKPercentage } = this.state;
        let price, incPR, finalPrice
        if (row.Part === 'Hood' || row.Part === 'Roof') {
            partArr = PriceCZ.ALLIANZ.roof
        } else if (row.Part === 'LeftFrontFender' || row.Part === 'LeftFrontDoor' || row.Part === 'LeftBackDoor' || row.Part === 'LeftBackFender' || row.Part === 'RightBackFender' || row.Part === 'RightBackDoor' || row.Part === 'RightFrontDoor' || row.Part === 'RightFrontFender') {
            partArr = PriceCZ.ALLIANZ.fender
        } else if (row.Part === 'Trunk' || row.Part === 'TrunkCover' || row.Part === 'RightRoofFrame' || row.Part === "LeftRoofFrame") {
            partArr = PriceCZ.ALLIANZ.trunk
        }

        // for filter total dents
        partArr.length && partArr.forEach((val) => {
            if (row.TotalDents === 0) {
                price = 0;
            } else if (row.TotalDents > 400 && row.TotalDents <= 500) {
                price = row.TotalDents * 35
            } else if (row.TotalDents > 501 && row.TotalDents <= 600) {
                price = row.TotalDents * 32
            } else {
                if (val.dents.min <= row.TotalDents && val.dents.max >= row.TotalDents) {
                    filterSizeArr.push(val.sizes)
                }
            }
        })

        // for sizes
        filterSizeArr && filterSizeArr[0] && filterSizeArr[0].length && filterSizeArr[0].forEach((sizes) => {
            if (sizes.size === row.AvgDiaMm) {
                price = sizes.value
            } else if (row.AvgDiaMm > 40 && sizes.size === 40) {
                price = sizes.value
            } else if (row.AvgDiaMm < 20 && sizes.size === 20) {
                price = sizes.value
            }
        })
        let aluPr = parseFloat(ALUPercentage);
        let lakPr = parseFloat(LAKPercentage);
        if (row.Alu && row.Push2paint) {
            //if Alu and lak both are enabled
            incPR = aluPr + lakPr;
        } else if (row.Alu) {
            //if only Alu is enabled
            incPR = aluPr;
        } else if (row.Push2paint) {
            //if only Push2paint is enabled
            incPR = lakPr;
        } else {
            //if only Push2paint is enabled
            incPR = 0;
        }
        if (incPR !== 0) {
            finalPrice = 0 || (
                parseFloat(price) +
                (parseFloat(price) * incPR) /
                100.0
            );
        } else {
            finalPrice = price;
        }
        finalPrice = Intl.NumberFormat('en-IN', { currency: 'CZK', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(finalPrice) // for 8,909.00
        return finalPrice
    }

    getTotalAw = () => {
        const { Dents } = this.state;
        let total = Dents && Dents.reduce(
            (acc, num, i) => {
                if (num.Part !== "TrunkCover" && num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
                    return (acc) + parseFloat(this.getAW(num, i).replace(/\,/g, ''));
                    // return (acc) + parseFloat(this.getAxaAW(num).replace(/\,/g,''));
                } else {
                    return (acc);
                }
            }
            ,
            0
        )
        total = Intl.NumberFormat('en-IN', { currency: 'CZK', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total)
        return total;
    }
    getRepairCost = () => {
        const { preparation, dismantling } = this.state;
        // const total = parseInt(preparation) + parseInt(dismantling) + parseFloat(this.getTotalAw());
        const total = this.getTotalAw();
        return total;
    }

    handleSave = () => {
        // let partnerId = localStorage.getItem("partnerId")
        // let vin = localStorage.getItem("selectedFile").split("_")[0];
        let { data, ShowPrice } = this.state;
        data["TotalDentCount"] = this.getTotalDents();
        data["ShowPrice"] = ShowPrice;
        data.Dents.forEach(part => {
            part.B = (part.B ? this.round10(parseInt(part.B), 1) : 0);
            part.AvgDiaMm = (part.B ? this.round10(parseInt(part.AvgDiaMm), 1) : 0);
            if (part.Plastic) {
                part.TotalDamages = 0;
                part.AvgDiaMm = 0;
                part.TotalDents = 0;
                part.A = 0;
                part.B = 0;
                part.C = 0;
                part.AddedCount = 0;
                part.OriginalAw = 0;
                part.AW = 0;
                part.Alu = false;
                part.Replace = false;
                part.Push2paint = false;
                part.Glue = false;
            }
        });

        Axios.get(
            `${configuration.getData}?vin=${localStorage.getItem("selectedFile")}&partnerId=${localStorage.getItem(
                "partnerId"
            )}`
        ).then((r) => {
            if (r.data) {
                data = {
                    ...data,
                    PartnerName: r.data.PartnerName,
                    Color: r.data.Color,
                    Comments: r.data.comment,
                    kilometerStand: r.data.kilometerStand,
                    Make: r.data.Make,
                    Model: r.data.Model,
                    RegNo: r.data.RegNo,
                    OrderNo: r.data.OrderNo,
                    ScannerLocation: r.data.ScannerLocation,
                    vin: r.data.Vin,
                    InsurenceName: r.data.InsurenceName,
                    Datetime: r.data.Datetime,
                    PartnerID: localStorage.getItem("partnerId")
                };
                this.setState({
                    data
                })
            }
        }).then(() => {
            const url =
                configuration.PostEditorChanges +
                `?partnerId=${localStorage.getItem(
                    "partnerId"
                )}&vin=${localStorage.getItem("selectedFile")}&TabViewUpdated=${!data.TabViewUpdated}`;
            Axios.post(url, {...data, IsPriceTableUpdated: true,}).then((res) => {
                Toast.fire({
                    type: "success",
                    title: "Data saved successfully",
                });
                this.getScanImages()
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            });
        })
    }

    ShowPrice = (e) => {
        this.setState({
            ShowPrice: e.target.checked
        }, () => this.updateJson())
    }

    updateJson = () => {
        const { data, ShowPrice } = this.state
        const url =
            configuration.PostEditorChanges +
            `?partnerId=${localStorage.getItem(
                "partnerId"
            )}&vin=${localStorage.getItem("selectedFile")}&TabViewUpdated=${false}`;
        let payload = {
            ...data,
            ShowPrice: ShowPrice
        }
        Axios.post(url, payload)
            .then((res) => {
                Toast.fire({
                    type: "success",
                    title: "Data saved successfully",
                });
            })
            .catch((err) => {
                Toast.fire({
                    type: "error",
                    title: "Something went wrong!",
                });
            })
    }

    // toggle = (partName, showImg) => {
    //     if (showImg) {
    //         this.setState({
    //             modal: !this.state.modal,
    //             imgPartName: partName
    //         });
    //     } else {
    //         this.setState({
    //             modal: !this.state.modal
    //         })
    //     }
    // }
    // toggle = (partName, showImg, isPlastic) => {
    //     if (showImg) {
    //       const imageArr = this.state.imageArr && this.state.imageArr.length > 0 && this.state.imageArr.filter((image) => {
    //         const spiltUrl = image.split("/")[6];
    //         const part = isPlastic
    //           ? spiltUrl && spiltUrl.split("_")[0]
    //           : spiltUrl && spiltUrl.split("_")[1];
    //         return part === partName;
    //       });
    //       this.setState({
    //         modal: !this.state.modal,
    //         imgPartName: partName,
    //         currentImageIndex: 0,
    //         filteredImages: imageArr, 
    //       });
    //     } else {
    //       this.setState({
    //         modal: !this.state.modal,
    //       });
    //     }
    //   };

    toggle = (partName, showImg, isPlastic) => {
        if (showImg) {
            const images = (configuration.imagePath == "https://backend.drivenscan.live" && this.props.toggleReportDamageImage) ? this.state.imageArrDamage : this.state.imageArr;
            const imageArr = images && images.length > 0 && images.filter((image) => {
                const spiltUrl = image.split("/")[(configuration.imagePath == "https://backend.drivenscan.live" && this.props.toggleReportDamageImage) ? 7 : 6];
                const reportInclude = spiltUrl && spiltUrl.includes("Report")
                const part = reportInclude ? spiltUrl && spiltUrl.split("_")[1] : spiltUrl && spiltUrl.split("_")[0];
                return part === partName;
            });
            this.setState({
                modal: !this.state.modal,
                imgPartName: partName,
                currentImageIndex: 0,
                filteredImages: imageArr,
            });
        } else {
            this.setState({
                modal: !this.state.modal,
            });
        }
    };

    render() {
        // const insuranceName = localStorage.getItem('InsurenceName') 
        const dynamic_Table_Colors = {
            '--table-even-color': this.state.rgbaColor || '#E8F3FF',
            '--table-header-color': this.state.insuaranceProvider.PrimaryColor || this.state.PrimaryColor || '#D80707',
            '--table-footer-color': this.state.insuaranceProvider.SecondaryColor || this.state.SecondaryColor || '#000',
            '--table-header-text-color': this.state.insuaranceProvider.HeaderTextColor || this.state.PrimaryTextColor || '#000',
            '--table-footer-text-color': this.state.insuaranceProvider.FooterTextColor || this.state.SecondaryTextColor || '#fff',
        };
        const { data, Dents, ShowPrice, modal, imgPartName, insuranceName, TabView } = this.state;
        const { is_extra_columns_visible } = this.props;
        const partnerId = localStorage.getItem('partnerId');
        const vin = localStorage.getItem('selectedFile');
        let numberOfZeros = 0
        let dentSizeData = 0
        let averageDentsSizeTotal = 0
        let dentsData = Dents && Dents.forEach(dents => {
            if (dents.B === 0) {
                numberOfZeros++
            } else {
                dentSizeData += dents.B
            }
        })
        averageDentsSizeTotal = Dents && Dents.length !== 0 ?
            Math.round(dentSizeData / (Dents.length - numberOfZeros)) : 0

        function findWithAttr(array, attr, value) {
            for (var i = 0; i < array.length; i += 1) {
                if (array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        }
        let srNo = 0;
        const { Authorized } = this.state.data
        return (
            <div className={`all-price-table-wrapper dns-pricetable cz-price-table-wrapper  ${this.props.viewType === 'TabView' ? "container-fluid" : "title-row-main container"}`}>
                <div className="row dns-price-table-row">
                    <div className="col-12 p-0 d-flex justify-content-between">
                        {/* <h3>
                            Damage <span> Summary </span>{" "}
                        </h3> */}
                        <div className='row p-0'>
                            <div className='col-lg-6 col-md-12 col-sm-6 p-0'>
                                <h3 className="report-title">{this.lang("Damage Description")} </h3>
                            </div>
                            {this.props.is_extra_columns_visible &&
                                <div className='col-lg-6 col-md-12 col-sm-6 text-right p-0 end-position-btn'>
                                    <div className="d-flex align-items-center justify-content-end">
                                        <>
                                            <div className="admin-list">
                                                <label className="name pr-2">{this.lang("ShowPrice")}</label>
                                                <div className="switch-button switch-button-lg">
                                                    <input disabled={Authorized} type="checkbox" name="item3" id="item3" value={ShowPrice} onClick={(e) => this.ShowPrice(e)} checked={ShowPrice} />
                                                    <span><label htmlFor="item3"></label></span>
                                                </div>
                                            </div>
                                            <button
                                                //  className='SubmitBut'
                                                style={{
                                                    // padding:'5px',
                                                    backgroundColor: '#F20000',
                                                    padding: "5px 10px",
                                                    color: 'white',
                                                    border: "none",
                                                    borderRadius: "5px",
                                                    fontSize: "16px",
                                                    marginLeft: "10px"

                                                }}
                                                onClick={this.handleSave}
                                            >
                                                {this.lang("Update Table")}
                                            </button>
                                        </>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className={`row cz_price_table_main  ${this.props.viewType === "TabView" ? "arrow_table_main_wrapper" : ""}`}>
                    <div className="col-lg-12 p-0">
                        <table
                            width="100%"
                            className=" table table-responsive-lg  w-100 cz_table_main"
                        >
                            <thead>
                                <tr width="100%">
                                    <th
                                        style={dynamic_Table_Colors}
                                        className={`part-tr both-top-border text-left ${this.props.viewType === 'TabView' ? "thead_bottom_border" : ""}`}
                                        width={is_extra_columns_visible ? "10%" : "50%"}
                                    // className="part-tr text-center"
                                    >
                                        {/* Part */}
                                        {this.lang("DamageDescription")}
                                    </th>
                                    <th className="empty_row"></th>
                                    {
                                        partnerId == "demo-cz" &&
                                        <>
                                            <th
                                                width={is_extra_columns_visible ? "5%" : "10%"}
                                                style={dynamic_Table_Colors}
                                                className={`alu-tr text-left both-top-border ${this.props.viewType === 'TabView' ? "thead_bottom_border dark-gray-col" : ""}`}
                                            >
                                                {this.lang("plastic")}
                                            </th>
                                            <th className="empty_row"></th>
                                        </>
                                    }


                                    {
                                        this.state.softwareType === 'HailInspectionPlusDamage' || this.state.softwareType === 'CarSoft' ?
                                            (
                                                <th
                                                    width='2%'
                                                >
                                                    {this.lang("Damages")}
                                                </th>
                                            )
                                            :
                                            ''
                                    }
                                    <th
                                        style={dynamic_Table_Colors}
                                        className={`min-width-130 average-size-tr top-left-border text-left ${this.props.viewType === 'TabView' ? "thead_bottom_border light-gray-col" : ""}`}
                                        width={"10%"}
                                    >
                                        {localStorage.getItem('partnerId') === '10-200410'
                                            ? this.lang("Total Scan Time")
                                            : this.lang("Total Dents")}
                                    </th>

                                    <th
                                        width={is_extra_columns_visible ? "10%" : "10%"}
                                        style={dynamic_Table_Colors}
                                        className={`min-width-130 dents-tr top-right-border text-left ${this.props.viewType === 'TabView' ? "thead_bottom_border light-gray-col" : ""}`}
                                    >
                                        {this.lang("Average Size")}
                                    </th>

                                    {localStorage.getItem('partnerId') === "1-190301" && <th
                                        width={"10%"}
                                        className="aw-tr"
                                    >
                                        Aw
                                    </th>}
                                    <th className="empty_row"></th>
                                    <th
                                        width={is_extra_columns_visible ? "5%" : "10%"}
                                        style={dynamic_Table_Colors}
                                        className={`alu-tr both-top-border text-left ${this.props.viewType === 'TabView' ? "thead_bottom_border orange-col" : ""}`}
                                    >
                                        {" "}
                                        {this.lang("Alu")}
                                        {/* Alu */}
                                        <br></br>
                                        {this.state.ALUPercentage
                                            ? `(${parseInt(this.state.ALUPercentage)}%)`
                                            : "10%"}
                                    </th>
                                    <th className="empty_row"></th>
                                    <th
                                        width={is_extra_columns_visible ? "5%" : "10%"}
                                        style={dynamic_Table_Colors}
                                        className={`lak-tr text-left both-top-border ${this.props.viewType === 'TabView' ? "thead_bottom_border green-col" : ""}`}
                                    >
                                        {/* Lak */}
                                        {this.lang("Lak")}

                                        <br></br>
                                        {this.state.LAKPercentage
                                            ? `(${parseInt(this.state.LAKPercentage)}%)`
                                            : "10%"}
                                    </th>
                                    <th className="empty_row"></th>
                                    <th
                                        width={is_extra_columns_visible ? "5%" : "10%"}
                                        style={dynamic_Table_Colors}
                                        className={`replace-tr text-left both-top-border ${this.props.viewType === 'TabView' ? "thead_bottom_border blue-col" : ""}`}
                                    >
                                        {this.lang("Replace")}
                                    </th>
                                    <th className="empty_row"></th>
                                    <th
                                        style={dynamic_Table_Colors}
                                        className={`replace-tr text-left both-top-border ${this.props.viewType === 'TabView' ? "thead_bottom_border blue-col" : ""}`}
                                        width={is_extra_columns_visible ? "5%" : "10%"} >
                                        {this.lang("Glue")}
                                    </th>
                                    {this.props.is_extra_columns_visible && (
                                        <>
                                            <th className="empty_row"></th>
                                            <th
                                                width="15%"
                                                style={dynamic_Table_Colors}
                                                className={`ae-tr text-left both-top-border ${this.props.viewType === 'TabView' ? "thead_bottom_border dark-gray-col" : ""}`}
                                            >
                                                A + E
                                            </th>
                                            <th className="empty_row"></th>
                                            <th
                                                width="15%"
                                                style={dynamic_Table_Colors}
                                                className={`ersetzen-tr text-left both-top-border ${this.props.viewType === 'TabView' ? "thead_bottom_border green-col" : ""}`}
                                            >
                                                {this.lang("Replace")}
                                            </th>
                                        </>
                                    )}
                                    <th className="empty_row"></th>
                                    {/* AW or C */}
                                    <th
                                        width="10%"
                                        style={dynamic_Table_Colors}
                                        className={`ersetzen-tr text-left both-top-border ${this.props.viewType === 'TabView' ? "thead_bottom_border" : ""}`}
                                    >
                                        {insuranceName !== 'Audatex' ? this.lang("Price") : "AW"}
                                    </th>
                                    {/* <th className="aw-tr">Aw1</th>
                                        <th className="aw-tr">Aw2</th> */}
                                </tr>
                            </thead>
                            <tbody width="100%">
                                {Dents &&
                                    Dents.map((row, index) => {
                                        if (row.Part !== "TrunkCover") {
                                            srNo = srNo + 1;
                                        }
                                        return (
                                            row.Part !== "TrunkCover" && row.Part !== "LeftFrontTyre" && row.Part !== "LeftBackTyre" && row.Part !== "RightFrontTyre" && row.Part !== "RightBackTyre" && row.Part !== "FrontBumper" && row.Part !== "BackBumper" && row.Part !== "Underbody" && row.Part !== "Inside" &&
                                            <tr key={index}>
                                                <td
                                                    style={dynamic_Table_Colors}
                                                    className="price-tbody-td">
                                                    {/* {this.lang(row.Part)}{" "} */}
                                                    <p className="m-0" onClick={() => this.props.is_extra_columns_visible && this.toggle(row.Part, true, row.Plastic)} style={{ cursor: "pointer", textDecoration: this.props.is_extra_columns_visible ? "underline" : "" }}>{this.lang(row.Part)}</p>

                                                    {!this.props.is_extra_columns_visible && (
                                                        <>
                                                            {/* <br></br> */}
                                                            {Array.isArray(row.AE) && row.AE.length
                                                                ? "("
                                                                : ""}
                                                            {Array.isArray(row.AE) &&
                                                                row.AE.map((data, index) => {
                                                                    return (
                                                                        <span>
                                                                            {this.lang(data)}
                                                                            {index == row.AE.length - 1 ? "" : ", "}
                                                                        </span>
                                                                    );
                                                                })}
                                                            {Array.isArray(row.AE) && row.AE.length
                                                                ? ")"
                                                                : ""}
                                                            {/* {Array.isArray(row.AE) && row.AE.length ? (
                                                                    <br />
                                                                    ) : (
                                                                    <></>
                                                                )} */}
                                                            {Array.isArray(row.Ersetzen) &&
                                                                row.Ersetzen.length
                                                                ? "("
                                                                : ""}
                                                            {Array.isArray(row.Ersetzen) &&
                                                                row.Ersetzen.map((data, index) => {
                                                                    return (
                                                                        <span>
                                                                            {this.lang(data)}
                                                                            {index == row.Ersetzen.length - 1
                                                                                ? ""
                                                                                : ", "}
                                                                        </span>
                                                                    );
                                                                })}
                                                            {Array.isArray(row.Ersetzen) &&
                                                                row.Ersetzen.length
                                                                ? ")"
                                                                : ""}
                                                        </>
                                                    )}
                                                </td>
                                                {/* Plastic */}
                                                <td className="empty_row"></td>
                                                {
                                                    partnerId == "demo-cz" &&
                                                    <>
                                                        <td
                                                            style={dynamic_Table_Colors}
                                                            className={`price-tbody-td text-center ${this.props.viewType === 'TabView' ? "dark-gray-col" : ""}`}
                                                        >
                                                            {(row.Part === "Trunk" && Dents[findWithAttr(Dents, 'Part', 'TrunkCover')]) ?
                                                                this.props.is_extra_columns_visible ?
                                                                    <>
                                                                        <input
                                                                            className="cross_input_table"
                                                                            type="checkbox"
                                                                            checked={row.Plastic || (Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].Plastic)}
                                                                            onChange={(e) => {
                                                                                this.plasticChange(row.Part, e, index, "Plastic");
                                                                            }}
                                                                            disabled={row.Replace || Authorized}
                                                                            id={index + "Plastic"}
                                                                        />
                                                                        <label
                                                                            className=""
                                                                            htmlFor={index + "Plastic"}
                                                                        />
                                                                    </>
                                                                    :
                                                                    row.Plastic ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''
                                                                :
                                                                this.props.is_extra_columns_visible ?
                                                                    <>
                                                                        <input
                                                                            className="cross_input_table"
                                                                            type="checkbox"
                                                                            checked={row.Plastic}
                                                                            onChange={(e) => {
                                                                                this.plasticChange(row.Part, e, index, "Plastic");
                                                                            }}
                                                                            disabled={row.Replace || Authorized}
                                                                            id={index + "Plastic"}

                                                                        />
                                                                        <label
                                                                            className=""
                                                                            htmlFor={index + "Plastic"}
                                                                        />
                                                                    </>
                                                                    :
                                                                    row.Plastic ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''
                                                            }

                                                        </td>
                                                        <td className="empty_row"></td>
                                                    </>
                                                }
                                                {/* show damges */}

                                                {
                                                    this.state.softwareType === 'HailInspectionPlusDamage' || this.state.softwareType === 'CarSoft' ?
                                                        ((row.Part === "Trunk" && Dents[findWithAttr(Dents, 'Part', 'TrunkCover')]) ?

                                                            <td className="" style={{ textAlign: "center" }}>
                                                                {(row.TotalDamages ? row.TotalDamages : 0) + (Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].TotalDamages ? Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].TotalDamages : 0)}
                                                            </td>
                                                            :
                                                            <td className="" style={{ textAlign: "center" }}>
                                                                {row.TotalDamages ? row.TotalDamages : 0}
                                                            </td>
                                                        ) :
                                                        ''
                                                }

                                                {/* show damges */}

                                                <td
                                                    style={dynamic_Table_Colors}
                                                    className={`price-tbody-td text-center ${this.props.viewType === 'TabView' ? "light-gray-col" : ""}`}
                                                >

                                                    {(row.Part === "Trunk" && Dents[findWithAttr(Dents, 'Part', 'TrunkCover')]) ?
                                                        this.props.is_extra_columns_visible ?
                                                            this.state.loadedFirstTime ?
                                                                <div style={{ position: 'relative', width: '100%' }}>
                                                                    <input
                                                                        name='TotalDents'
                                                                        type='number'
                                                                        style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                                                        value={row.TotalDents + (Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].TotalDents ? Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].TotalDents : 0)}
                                                                        min='0'
                                                                        disabled={Authorized}
                                                                        // max='80'
                                                                        onChange={(e) => !row.Plastic && this.handleChange(row.Part, index, e)}
                                                                    />
                                                                    {!data.Authorized &&
                                                                        <>
                                                                            <div className="button-table-arrow-position">
                                                                                <button
                                                                                    onClick={() => {
                                                                                        const updatedValue = Math.max((parseInt(row.TotalDents) || 0) - 1, 0);
                                                                                        this.handleChange(row.Part, index, { target: { name: 'TotalDents', value: updatedValue } });
                                                                                    }}
                                                                                    disabled={data.Authorized || row.Plastic}
                                                                                    className="decrement-button"
                                                                                >
                                                                                    -
                                                                                </button>
                                                                                <button
                                                                                    onClick={() => {
                                                                                        const updatedValue = (parseInt(row.TotalDents) || 0) + 1;
                                                                                        this.handleChange(row.Part, index, { target: { name: 'TotalDents', value: updatedValue } });
                                                                                    }}
                                                                                    disabled={data.Authorized || row.Plastic}
                                                                                    className="increment-button"
                                                                                >
                                                                                    +
                                                                                </button>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </div>
                                                                :
                                                                <div style={{ position: 'relative', width: '100%' }}>
                                                                    <input
                                                                        name='TotalDents'
                                                                        type='number'
                                                                        disabled={Authorized}
                                                                        style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                                                        value={row.TotalDents}
                                                                        min='0'
                                                                        // max='80'
                                                                        onChange={(e) => !row.Plastic && this.handleChange(row.Part, index, e)}
                                                                    />
                                                                    {!data.Authorized &&
                                                                        <>
                                                                            <div className="button-table-arrow-position">
                                                                                <button
                                                                                    onClick={() => {
                                                                                        const updatedValue = Math.max((parseInt(row.TotalDents) || 0) - 1, 0);
                                                                                        this.handleChange(row.Part, index, { target: { name: 'TotalDents', value: updatedValue } });
                                                                                    }}
                                                                                    disabled={data.Authorized || row.Plastic}
                                                                                    className="decrement-button"
                                                                                >
                                                                                    -
                                                                                </button>
                                                                                <button
                                                                                    onClick={() => {
                                                                                        const updatedValue = (parseInt(row.TotalDents) || 0) + 1;
                                                                                        this.handleChange(row.Part, index, { target: { name: 'TotalDents', value: updatedValue } });
                                                                                    }}
                                                                                    disabled={data.Authorized || row.Plastic}
                                                                                    className="increment-button"
                                                                                >
                                                                                    +
                                                                                </button>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </div>

                                                            :
                                                            <p style={{ color: `${(row.TotalDents > 250) ? 'red' : ''}` }}>
                                                                {row.TotalDents + (Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].TotalDents ? Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].TotalDents : 0)}
                                                            </p>
                                                        :
                                                        this.props.is_extra_columns_visible ?
                                                            <div style={{ position: 'relative', width: '100%' }}>
                                                                <input
                                                                    name='TotalDents'
                                                                    type='number'
                                                                    disabled={Authorized}
                                                                    style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                                                    value={row.TotalDents}
                                                                    min='0'
                                                                    // max='80'
                                                                    onChange={(e) => !row.Plastic && this.handleChange(row.Part, index, e)}
                                                                />
                                                                {!data.Authorized &&
                                                                    <>
                                                                        <div className="button-table-arrow-position">
                                                                            <button
                                                                                onClick={() => {
                                                                                    const updatedValue = Math.max((parseInt(row.TotalDents) || 0) - 1, 0);
                                                                                    this.handleChange(row.Part, index, { target: { name: 'TotalDents', value: updatedValue } });
                                                                                }}
                                                                                disabled={data.Authorized || row.Plastic}
                                                                                className="decrement-button"
                                                                            >
                                                                                -
                                                                            </button>
                                                                            <button
                                                                                onClick={() => {
                                                                                    const updatedValue = (parseInt(row.TotalDents) || 0) + 1;
                                                                                    this.handleChange(row.Part, index, { target: { name: 'TotalDents', value: updatedValue } });
                                                                                }}
                                                                                disabled={data.Authorized || row.Plastic}
                                                                                className="increment-button"
                                                                            >
                                                                                +
                                                                            </button>
                                                                        </div>
                                                                    </>
                                                                }
                                                            </div>
                                                            :
                                                            <p style={{ color: `${(row.TotalDents > 250) ? 'red' : ''}` }}>
                                                                {row.TotalDents}
                                                            </p>
                                                    }
                                                </td>

                                                <td
                                                    style={dynamic_Table_Colors}
                                                    className={`price-tbody-td text-center ${this.props.viewType === 'TabView' ? "light-gray-col" : ""}`}
                                                >
                                                    {/* {avgSizeRoundOff[index]} */}
                                                    {(row.Part === "Trunk" && Dents[findWithAttr(Dents, 'Part', 'TrunkCover')]) ?
                                                        this.props.is_extra_columns_visible ?
                                                            this.state.loadedFirstTimeAVG ?
                                                                this.state.loadedFirstTime ?
                                                                    <div style={{ position: 'relative', width: '100%' }}>
                                                                        <input
                                                                            name='B'
                                                                            type='number'
                                                                            disabled={Authorized}
                                                                            style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                                                            value={(row.B == '0' || Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].B == '0') ? this.round10(row.B, 1) + this.round10(Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].B, 1) : this.round10((row.B + Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].B) / 2, 1)}
                                                                            min='0'
                                                                            step='10'
                                                                            max='80'
                                                                            onChange={(e) => !row.Plastic && this.handleChange(row.Part, index, e, 'loadedFirstTimeAVG')}
                                                                        />
                                                                        {!data.Authorized &&
                                                                            <>
                                                                                <div className="button-table-arrow-position">
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            const updatedValue = Math.max((parseInt(row.B) || 0) - 10, 0);
                                                                                            this.handleChange(row.Part, index, { target: { name: 'B', value: updatedValue } }, 'loadedFirstTimeAVG');
                                                                                        }}
                                                                                        disabled={data.Authorized || row.Plastic}
                                                                                        className="decrement-button"
                                                                                    >
                                                                                        -
                                                                                    </button>
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            const updatedValue = Math.min((parseInt(row.B) || 0) + 10, 80);
                                                                                            this.handleChange(row.Part, index, { target: { name: 'B', value: updatedValue } }, 'loadedFirstTimeAVG');
                                                                                        }}
                                                                                        disabled={data.Authorized || row.Plastic}
                                                                                        className="increment-button"
                                                                                    >
                                                                                        +
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        }
                                                                    </div>

                                                                    :
                                                                    <div style={{ position: 'relative', width: '100%' }}>
                                                                        <input
                                                                            name='B'
                                                                            type='number'
                                                                            disabled={Authorized}
                                                                            style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                                                            value={row.B}
                                                                            min='0'
                                                                            max='80'
                                                                            step='10'
                                                                            onChange={(e) => !row.Plastic && this.handleChange(row.Part, index, e)}
                                                                        />
                                                                        {!data.Authorized &&
                                                                            <>
                                                                                <div className="button-table-arrow-position">
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            const updatedValue = Math.max((parseInt(row.B) || 0) - 10, 0);
                                                                                            this.handleChange(row.Part, index, { target: { name: 'B', value: updatedValue } });
                                                                                        }}
                                                                                        disabled={data.Authorized || row.Plastic}
                                                                                        className="decrement-button"
                                                                                    >
                                                                                        -
                                                                                    </button>
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            const updatedValue = Math.min((parseInt(row.B) || 0) + 10, 80);
                                                                                            this.handleChange(row.Part, index, { target: { name: 'B', value: updatedValue } });
                                                                                        }}
                                                                                        disabled={data.Authorized || row.Plastic}
                                                                                        className="increment-button"
                                                                                    >
                                                                                        +
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        }
                                                                    </div>

                                                                :

                                                                this.state.loadedFirstTime ?
                                                                    <div style={{ position: 'relative', width: '100%' }}>
                                                                        <input
                                                                            name='B'
                                                                            type='number'
                                                                            disabled={Authorized}
                                                                            style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                                                            value={this.round10(row.B, 1)}
                                                                            min='0'
                                                                            step='10'
                                                                            max='80'
                                                                            onChange={(e) => !row.Plastic && this.handleChange(row.Part, index, e)}
                                                                        />
                                                                        {!data.Authorized &&
                                                                            <>
                                                                                <div className="button-table-arrow-position">
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            const updatedValue = Math.max((parseInt(row.B) || 0) - 10, 0);
                                                                                            this.handleChange(row.Part, index, { target: { name: 'B', value: updatedValue } });
                                                                                        }}
                                                                                        disabled={data.Authorized || row.Plastic}
                                                                                        className="decrement-button"
                                                                                    >
                                                                                        -
                                                                                    </button>
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            const updatedValue = Math.min((parseInt(row.B) || 0) + 10, 80);
                                                                                            this.handleChange(row.Part, index, { target: { name: 'B', value: updatedValue } });
                                                                                        }}
                                                                                        disabled={data.Authorized || row.Plastic}
                                                                                        className="increment-button"
                                                                                    >
                                                                                        +
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        }
                                                                    </div>

                                                                    :
                                                                    <div style={{ position: 'relative', width: '100%' }}>
                                                                        <input
                                                                            name='B'
                                                                            type='number'
                                                                            disabled={Authorized}
                                                                            style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                                                            value={row.B}
                                                                            min='0'
                                                                            max='80'
                                                                            step='10'
                                                                            onChange={(e) => !row.Plastic && this.handleChange(row.Part, index, e)}
                                                                        />
                                                                        {!data.Authorized &&
                                                                            <>
                                                                                <div className="button-table-arrow-position">
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            const updatedValue = Math.max((parseInt(row.B) || 0) - 10, 0);
                                                                                            this.handleChange(row.Part, index, { target: { name: 'B', value: updatedValue } });
                                                                                        }}
                                                                                        disabled={data.Authorized || row.Plastic}
                                                                                        className="decrement-button"
                                                                                    >
                                                                                        -
                                                                                    </button>
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            const updatedValue = Math.min((parseInt(row.B) || 0) + 10, 80);
                                                                                            this.handleChange(row.Part, index, { target: { name: 'B', value: updatedValue } });
                                                                                        }}
                                                                                        disabled={data.Authorized || row.Plastic}
                                                                                        className="increment-button"
                                                                                    >
                                                                                        +
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        }
                                                                    </div>
                                                            :
                                                            <p>
                                                                {(row.B == '0' || Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].B == '0') ? this.round10(row.B, 1) + this.round10(Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].B, 1) : this.round10((row.B + Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].B) / 2, 1)}
                                                            </p>
                                                        :
                                                        this.props.is_extra_columns_visible ?
                                                            this.state.loadedFirstTime ?
                                                                <div style={{ position: 'relative', width: '100%' }}>
                                                                    <input
                                                                        name='B'
                                                                        type='number'
                                                                        disabled={Authorized}
                                                                        style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                                                        value={this.round10(row.B, 1)}
                                                                        min='0'
                                                                        step='10'
                                                                        max='80'
                                                                        onChange={(e) => !row.Plastic && this.handleChange(row.Part, index, e)}
                                                                    />
                                                                    {!data.Authorized &&
                                                                        <>
                                                                            <div className="button-table-arrow-position">
                                                                                <button
                                                                                    onClick={() => {
                                                                                        const updatedValue = Math.max((parseInt(row.B) || 0) - 10, 0);
                                                                                        this.handleChange(row.Part, index, { target: { name: 'B', value: updatedValue } });
                                                                                    }}
                                                                                    disabled={data.Authorized || row.Plastic}
                                                                                    className="decrement-button"
                                                                                >
                                                                                    -
                                                                                </button>
                                                                                <button
                                                                                    onClick={() => {
                                                                                        const updatedValue = Math.min((parseInt(row.B) || 0) + 10, 80);
                                                                                        this.handleChange(row.Part, index, { target: { name: 'B', value: updatedValue } });
                                                                                    }}
                                                                                    disabled={data.Authorized || row.Plastic}
                                                                                    className="increment-button"
                                                                                >
                                                                                    +
                                                                                </button>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </div>
                                                                :
                                                                <div style={{ position: 'relative', width: '100%' }}>
                                                                    <input
                                                                        name='B'
                                                                        type='number'
                                                                        disabled={Authorized}
                                                                        style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                                                        value={row.B}
                                                                        min='0'
                                                                        max='80'
                                                                        step='10'

                                                                        onChange={(e) => !row.Plastic && this.handleChange(row.Part, index, e)}
                                                                    />
                                                                    {!data.Authorized &&
                                                                        <>
                                                                            <div className="button-table-arrow-position">
                                                                                <button
                                                                                    onClick={() => {
                                                                                        const updatedValue = Math.max((parseInt(row.B) || 0) - 10, 0);
                                                                                        this.handleChange(row.Part, index, { target: { name: 'B', value: updatedValue } });
                                                                                    }}
                                                                                    disabled={data.Authorized || row.Plastic}
                                                                                    className="decrement-button"
                                                                                >
                                                                                    -
                                                                                </button>
                                                                                <button
                                                                                    onClick={() => {
                                                                                        const updatedValue = Math.min((parseInt(row.B) || 0) + 10, 80);
                                                                                        this.handleChange(row.Part, index, { target: { name: 'B', value: updatedValue } });
                                                                                    }}
                                                                                    disabled={data.Authorized || row.Plastic}
                                                                                    className="increment-button"
                                                                                >
                                                                                    +
                                                                                </button>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </div>
                                                            :
                                                            <p>
                                                                {this.round10(row.B, 1)}
                                                            </p>
                                                    }
                                                    {/* {this.round10(row.AvgDiaMm, 1)} */}
                                                    {/* {row.AvgDiaMm} */}
                                                </td>

                                                <td className="empty_row"></td>


                                                {localStorage.getItem('partnerId') === "1-190301" &&
                                                    <td
                                                        style={{ textAlign: "center" }}
                                                    >
                                                        {(row.Part === "Trunk" && Dents[findWithAttr(Dents, 'Part', 'TrunkCover')]) ?
                                                            this.props.is_extra_columns_visible ?
                                                                this.state.loadedFirstTime ?
                                                                    <div style={{ position: 'relative', width: '100%' }}>
                                                                        <input
                                                                            name='AW'
                                                                            disabled={Authorized}
                                                                            type='number'

                                                                            style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                                                            value={row.AW + (Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].AW)}
                                                                            min='0'
                                                                            onChange={(e) => this.handleChange(row.Part, index, e)}
                                                                        />
                                                                        {!data.Authorized &&
                                                                            <>
                                                                                <div className="button-table-arrow-position">
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            const updatedValue = Math.max((parseInt(row.AW + (Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].AW)) || 0) - 1, 0);
                                                                                            this.handleChange(row.Part, index, { target: { name: 'AW', value: updatedValue } });
                                                                                        }}
                                                                                        disabled={data.Authorized || row.Plastic}
                                                                                        className="decrement-button"
                                                                                    >
                                                                                        -
                                                                                    </button>
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            const updatedValue = (parseInt(row.AW + (Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].AW)) || 0) + 1;
                                                                                            this.handleChange(row.Part, index, { target: { name: 'AW', value: updatedValue } });
                                                                                        }}
                                                                                        disabled={data.Authorized || row.Plastic}
                                                                                        className="increment-button"
                                                                                    >
                                                                                        +
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        }
                                                                    </div>
                                                                    :
                                                                    <div style={{ position: 'relative', width: '100%' }}>
                                                                        <input
                                                                            name='AW'
                                                                            disabled={Authorized}
                                                                            type='number'
                                                                            style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                                                            value={row.AW}
                                                                            min='0'
                                                                            onChange={(e) => this.handleChange(row.Part, index, e)}
                                                                        />
                                                                        {!data.Authorized &&
                                                                            <>
                                                                                <div className="button-table-arrow-position">
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            const updatedValue = Math.max((parseInt(row.AW) || 0) - 1, 0);
                                                                                            this.handleChange(row.Part, index, { target: { name: 'AW', value: updatedValue } });
                                                                                        }}
                                                                                        disabled={data.Authorized || row.Plastic}
                                                                                        className="decrement-button"
                                                                                    >
                                                                                        -
                                                                                    </button>
                                                                                    <button
                                                                                        onClick={() => {
                                                                                            const updatedValue = (parseInt(row.AW) || 0) + 1;
                                                                                            this.handleChange(row.Part, index, { target: { name: 'AW', value: updatedValue } });
                                                                                        }}
                                                                                        disabled={data.Authorized || row.Plastic}
                                                                                        className="increment-button"
                                                                                    >
                                                                                        +
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        }
                                                                    </div>
                                                                :
                                                                <p>
                                                                    {row.AW + (Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].AW)}
                                                                </p>
                                                            :
                                                            this.props.is_extra_columns_visible ?
                                                                <div style={{ position: 'relative', width: '100%' }}>
                                                                    <input
                                                                        name='AW'
                                                                        type='number'
                                                                        disabled={Authorized}
                                                                        style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                                                        value={row.AW}
                                                                        min='0'
                                                                        onChange={(e) => this.handleChange(row.Part, index, e)}
                                                                    />
                                                                    {!data.Authorized &&
                                                                        <>
                                                                            <div className="button-table-arrow-position">
                                                                                <button
                                                                                    onClick={() => {
                                                                                        const updatedValue = Math.max((parseInt(row.AW) || 0) - 1, 0);
                                                                                        this.handleChange(row.Part, index, { target: { name: 'AW', value: updatedValue } });
                                                                                    }}
                                                                                    disabled={data.Authorized || row.Plastic}
                                                                                    className="decrement-button"
                                                                                >
                                                                                    -
                                                                                </button>
                                                                                <button
                                                                                    onClick={() => {
                                                                                        const updatedValue = (parseInt(row.AW) || 0) + 1;
                                                                                        this.handleChange(row.Part, index, { target: { name: 'AW', value: updatedValue } });
                                                                                    }}
                                                                                    disabled={data.Authorized || row.Plastic}
                                                                                    className="increment-button"
                                                                                >
                                                                                    +
                                                                                </button>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </div>
                                                                :
                                                                <p>
                                                                    {row.AW}
                                                                </p>
                                                        }

                                                    </td>}

                                                <td
                                                    style={dynamic_Table_Colors}
                                                    className={`price-tbody-td text-center ${this.props.viewType === 'TabView' ? "orange-col" : ""}`}
                                                >
                                                    {(row.Part === "Trunk" && Dents[findWithAttr(Dents, 'Part', 'TrunkCover')]) ?
                                                        this.props.is_extra_columns_visible ?
                                                            <>
                                                                <input
                                                                    className="cross_input_table"
                                                                    type="checkbox"
                                                                    disabled={Authorized}
                                                                    checked={row.Plastic ? false : row.Alu || (Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].Alu)}
                                                                    onChange={(e) => {
                                                                        !row.Plastic &&
                                                                            this.change(row.Part, e, index, "Alu");
                                                                    }}

                                                                    id={index + "Alu"}
                                                                />
                                                                <label
                                                                    className=""
                                                                    htmlFor={index + "Alu"}
                                                                />
                                                            </>
                                                            :
                                                            row.Alu ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''
                                                        :
                                                        this.props.is_extra_columns_visible ?
                                                            <>
                                                                <input
                                                                    className="cross_input_table"
                                                                    disabled={Authorized}
                                                                    type="checkbox"
                                                                    checked={row.Plastic ? false : row.Alu}
                                                                    onChange={(e) => {
                                                                        !row.Plastic &&
                                                                            this.change(row.Part, e, index, "Alu");
                                                                    }}
                                                                    id={index + "Alu"}

                                                                />
                                                                <label
                                                                    className=""
                                                                    htmlFor={index + "Alu"}
                                                                />
                                                            </>
                                                            :
                                                            row.Alu ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''
                                                    }

                                                </td>
                                                <td className="empty_row"></td>
                                                <td
                                                    style={dynamic_Table_Colors}
                                                    className={`price-tbody-td text-center ${this.props.viewType === 'TabView' ? "green-col" : ""}`}
                                                >
                                                    {(row.Part === "Trunk" && Dents[findWithAttr(Dents, 'Part', 'TrunkCover')]) ?
                                                        this.props.is_extra_columns_visible ?
                                                            <>
                                                                <input
                                                                    className="cross_input_table"
                                                                    disabled={Authorized}
                                                                    type="checkbox"
                                                                    checked={row.Plastic ? false : row.Push2paint || (Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].Push2paint)}
                                                                    onChange={(e) => {
                                                                        !row.Plastic &&
                                                                            this.change(row.Part, e, index, "Push2paint");
                                                                    }}

                                                                    id={index + "Push2paint"}
                                                                />
                                                                <label
                                                                    className=""
                                                                    htmlFor={index + "Push2paint"}
                                                                />
                                                            </>
                                                            :
                                                            row.Push2paint ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''

                                                        :
                                                        this.props.is_extra_columns_visible ?
                                                            <>
                                                                <input
                                                                    className="cross_input_table"
                                                                    type="checkbox"
                                                                    disabled={Authorized}
                                                                    checked={row.Plastic ? false : row.Push2paint}
                                                                    onChange={(e) => {
                                                                        !row.Plastic &&
                                                                            this.change(row.Part, e, index, "Push2paint");
                                                                    }}

                                                                    id={index + "Push2paint"}
                                                                />
                                                                <label
                                                                    className=""
                                                                    htmlFor={index + "Push2paint"}
                                                                />
                                                            </>
                                                            :
                                                            row.Push2paint ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''
                                                    }
                                                </td>
                                                <td className="empty_row"></td>
                                                <td
                                                    style={dynamic_Table_Colors}
                                                    className={`price-tbody-td text-center ${this.props.viewType === 'TabView' ? "blue-col" : ""}`}
                                                >
                                                    {(row.Part === "Trunk" && Dents[findWithAttr(Dents, 'Part', 'TrunkCover')]) ?
                                                        this.props.is_extra_columns_visible ?
                                                            <>
                                                                <input
                                                                    className="cross_input_table"
                                                                    type="checkbox"

                                                                    checked={row.Plastic ? false : row.Replace || Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].Replace}
                                                                    onChange={(e) => {
                                                                        !row.Plastic &&
                                                                            this.change(row.Part, e, index, "Replace");
                                                                    }}
                                                                    disabled={!this.props.is_extra_columns_visible || row.Plastic || Authorized}
                                                                    id={index + "Replace"}
                                                                />
                                                                <label
                                                                    className=""
                                                                    htmlFor={index + "Replace"}
                                                                />
                                                            </>
                                                            :
                                                            row.Replace ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''

                                                        :
                                                        this.props.is_extra_columns_visible ?
                                                            <>
                                                                <input
                                                                    className="cross_input_table"
                                                                    type="checkbox"
                                                                    checked={row.Plastic ? false : row.Replace}
                                                                    onChange={(e) => {

                                                                        !row.Plastic &&
                                                                            this.change(row.Part, e, index, "Replace");
                                                                    }}
                                                                    disabled={!this.props.is_extra_columns_visible || row.Plastic || Authorized}
                                                                    id={index + "Replace"}
                                                                />
                                                                <label
                                                                    className=""
                                                                    htmlFor={index + "Replace"}
                                                                />
                                                            </>
                                                            :
                                                            row.Replace ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''
                                                    }
                                                </td>
                                                <td className="empty_row"></td>

                                                {/* <td className="" style={{ textAlign: "center" }}>
                                                        {row.AW}
                                                    </td>*/}
                                                <td
                                                    style={dynamic_Table_Colors}
                                                    className={`price-tbody-td text-center ${this.props.viewType === 'TabView' ? "blue-col" : ""}`}
                                                >
                                                    {(row.Part === "Trunk" && Dents[findWithAttr(Dents, 'Part', 'TrunkCover')]) ?
                                                        this.props.is_extra_columns_visible ?
                                                            <>
                                                                <input
                                                                    className="cross_input_table"
                                                                    type="checkbox"
                                                                    disabled={Authorized}
                                                                    checked={row.Plastic ? false : row.Glue || Dents[findWithAttr(Dents, 'Part', 'TrunkCover')].Glue}
                                                                    onChange={(e) => {
                                                                        !row.Plastic &&
                                                                            this.change(row.Part, e, index, "Glue");
                                                                    }}
                                                                    id={index + "Glue"}
                                                                />
                                                                <label
                                                                    className=""
                                                                    htmlFor={index + "Glue"}
                                                                />
                                                            </>
                                                            :
                                                            (row.Glue) ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''
                                                        :
                                                        this.props.is_extra_columns_visible ?
                                                            <>
                                                                <input
                                                                    className="cross_input_table"
                                                                    type="checkbox"
                                                                    disabled={Authorized}
                                                                    checked={row.Plastic ? false : row.Glue}
                                                                    onChange={(e) => {
                                                                        !row.Plastic &&
                                                                            this.change(row.Part, e, index, "Glue");
                                                                    }}
                                                                    id={index + "Glue"}
                                                                />
                                                                <label
                                                                    className=""
                                                                    htmlFor={index + "Glue"}
                                                                />
                                                            </>
                                                            :
                                                            row.Glue ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''
                                                    }
                                                </td>

                                                {this.props.is_extra_columns_visible && (
                                                    <>
                                                        <td className="empty_row"></td>
                                                        <td
                                                            style={dynamic_Table_Colors}
                                                            className={`price-tbody-td text-center ${this.props.viewType === 'TabView' ? "dark-gray-col" : ""}`}
                                                        >
                                                            <div className="ae-content p-0">
                                                                <div className="row p-0">
                                                                    {Array.isArray(row.arrAE) &&
                                                                        row.arrAE.map((checkbox_val) => {
                                                                            return (
                                                                                <>
                                                                                    <div className="col-lg-12 col-md-12 col-sm-12 p-0 d-flex">
                                                                                        <div className="alu_input_main">
                                                                                            <div className="alu_input_content">
                                                                                                <input
                                                                                                    className="cross_input_table"
                                                                                                    type="checkbox"
                                                                                                    disabled={Authorized}
                                                                                                    checked={
                                                                                                        Array.isArray(
                                                                                                            Dents[index]["AE"]
                                                                                                        ) &&
                                                                                                            Dents[index]["AE"].includes(
                                                                                                                checkbox_val
                                                                                                            )
                                                                                                            ? true
                                                                                                            : false
                                                                                                    }
                                                                                                    onClick={(event) =>
                                                                                                        this.changeAE(
                                                                                                            event,
                                                                                                            index,
                                                                                                            checkbox_val
                                                                                                        )
                                                                                                    }
                                                                                                />
                                                                                            </div>
                                                                                            <div className="alu_para_content">
                                                                                                <p>{this.lang(checkbox_val)}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            );
                                                                        })}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="empty_row"></td>
                                                        <td
                                                            style={dynamic_Table_Colors}
                                                            className={`price-tbody-td text-center ${this.props.viewType === 'TabView' ? "green-col" : ""}`}
                                                        >
                                                            <div className="ae-content p-0">
                                                                <div className="row p-0">
                                                                    {Array.isArray(row.arrErsetzen) &&
                                                                        row.arrErsetzen.map((checkbox_val) => {
                                                                            return (
                                                                                <>
                                                                                    <div className="col-lg-12 col-md-12 col-sm-12 p-0 d-flex">
                                                                                        <div className="alu_input_main">
                                                                                            <div className="alu_input_content">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    disabled={Authorized}
                                                                                                    className="cross_input_table"
                                                                                                    checked={
                                                                                                        Array.isArray(
                                                                                                            Dents[index]["Ersetzen"]
                                                                                                        ) &&
                                                                                                            Dents[index][
                                                                                                                "Ersetzen"
                                                                                                            ].includes(checkbox_val)
                                                                                                            ? true
                                                                                                            : false
                                                                                                    }
                                                                                                    onClick={(event) =>
                                                                                                        this.changeErsetzen(
                                                                                                            event,
                                                                                                            index,
                                                                                                            checkbox_val
                                                                                                        )
                                                                                                    }
                                                                                                />
                                                                                            </div>
                                                                                            <div className="alu_para_content">
                                                                                                <p>{this.lang(checkbox_val)}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            );
                                                                        })}
                                                                </div>
                                                            </div>
                                                        </td>

                                                    </>
                                                )}
                                                <td className="empty_row"></td>
                                                <td
                                                    style={{
                                                        color: `${["Axa", "Slavia", "Direct", "Audatex", "Allianz"].includes(insuranceName)
                                                            ? ""
                                                            : "red"
                                                            }`,
                                                        textAlign: "right",
                                                        fontWeight: "normal",
                                                        ...dynamic_Table_Colors
                                                    }}
                                                    className="text-center"
                                                // style={{ color: `${["Axa", "Slavia", "Direct", "Audatex", "Allianz"].includes(insuranceName) ? "" : "red"}` }}
                                                >
                                                    {ShowPrice &&
                                                        this.getAW(row, index)
                                                    }
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                            <tfoot className="cz_footer">
                                <tr className="last_tr_tbody">
                                    <td
                                        style={dynamic_Table_Colors}
                                        className={`both-bottom-border ${this.props.viewType === 'TabView' ? "" : ""}`}
                                    >
                                        {this.lang("Total")}
                                    </td>
                                    <td className="empty_row"></td>
                                    {
                                        partnerId == "demo-cz" &&
                                        <>
                                            <td
                                                style={dynamic_Table_Colors}
                                                className={`both-bottom-border ${this.props.viewType === 'TabView' ? "dark-gray-col thead_top_border" : ""}`}
                                            ></td>
                                            <td className="empty_row"></td>
                                        </>
                                    }

                                    {
                                        ((this.state.softwareType === "HailInspectionPlusDamage") || (this.state.softwareType === 'CarSoft')) &&

                                        <td style={{ textAlign: "center" }}>
                                            <b>
                                                {Dents && this.totalDamages(Dents)}
                                            </b>
                                        </td>

                                    }

                                    <td
                                        style={dynamic_Table_Colors}
                                        className={`bottom-left-border ${this.props.viewType === 'TabView' ? "light-gray-col thead_top_border" : ""}`}
                                    >
                                        {Dents &&
                                            isNaN(Dents && Dents.reduce(
                                                (acc, num) => parseInt(acc) + num.TotalDents,
                                                0
                                            )) ? 0 : Dents && Dents.reduce(
                                                (acc, num) => parseInt(acc) + num.TotalDents,
                                                0
                                            ).toFixed(2)}
                                    </td>

                                    <td
                                        style={dynamic_Table_Colors}
                                        className={`bottom-right-border ${this.props.viewType === 'TabView' ? "light-gray-col thead_top_border" : ""}`}
                                    >

                                        {
                                            Dents &&
                                                isNaN(this.round10(averageDentsSizeTotal, 1))
                                                ? 0 : this.round10(averageDentsSizeTotal, 1).toFixed(2)
                                        }
                                        {/* {Dents &&
                                            isNaN(this.avg(
                                            parseInt(
                                                Dents.reduce((acc, num) => {
                                                return parseInt(acc) + num.AvgDiaMm;
                                                }, 0) /
                                                Dents.reduce(
                                                    (acc, num) => parseInt(acc) + num.TotalDents,
                                                    0
                                                )
                                            )
                                            )) ? 0 : this.avg(
                                            parseInt(
                                                Dents.reduce((acc, num) => {
                                                return parseInt(acc) + num.AvgDiaMm;
                                                }, 0) /
                                                Dents.reduce(
                                                    (acc, num) => parseInt(acc) + num.TotalDents,
                                                    0
                                                )
                                            )
                                            )} */}

                                    </td>

                                    <td className="empty_row"></td>

                                    {localStorage.getItem('partnerId') === "1-190301" && <td style={{ textAlign: "center" }}>
                                        <b>
                                            {Dents &&
                                                isNaN(parseInt(
                                                    Dents.reduce((acc, num) => parseInt(acc) + num.AW, 0)
                                                )) ? 0 : parseInt(
                                                    Dents.reduce((acc, num) => parseInt(acc) + num.AW, 0)
                                                )}
                                        </b>
                                    </td>}
                                    <td
                                        style={dynamic_Table_Colors}
                                        className={`both-bottom-border ${this.props.viewType === 'TabView' ? "orange-col thead_top_border" : ""}`}
                                    ></td>
                                    <td className="empty_row"></td>
                                    <td
                                        style={dynamic_Table_Colors}
                                        className={`both-bottom-border ${this.props.viewType === 'TabView' ? "green-col thead_top_border" : ""}`}
                                    ></td>
                                    <td className="empty_row"></td>
                                    <td
                                        style={dynamic_Table_Colors}
                                        className={`both-bottom-border ${this.props.viewType === 'TabView' ? "blue-col thead_top_border" : ""}`}
                                    ></td>
                                    <td className="empty_row"></td>
                                    <td
                                        style={dynamic_Table_Colors}
                                        className={`both-bottom-border ${this.props.viewType === 'TabView' ? "blue-col thead_top_border" : ""}`}
                                    ></td>



                                    {this.props.is_extra_columns_visible && (
                                        <>
                                            <td className="empty_row"></td>
                                            <td
                                                style={dynamic_Table_Colors}
                                                className={`both-bottom-border ${this.props.viewType === 'TabView' ? "dark-gray-col thead_top_border" : ""}`}
                                            >

                                            </td>
                                            <td className="empty_row"></td>
                                            <td
                                                style={dynamic_Table_Colors}
                                                className={`both-bottom-border ${this.props.viewType === 'TabView' ? "green-col thead_top_border" : ""}`}
                                            ></td>
                                        </>
                                    )}
                                    <td className="empty_row"></td>

                                    <td
                                        style={{
                                            color: `${["Axa", "Slavia", "Direct", "Audatex", "Allianz"].includes(insuranceName)
                                                ? ""
                                                : "red"
                                                }`,
                                            ...dynamic_Table_Colors
                                        }}
                                        className={`both-bottom-border text-center ${this.props.viewType === 'TabView' ? "thead_top_border" : ""}`}

                                    >
                                        {ShowPrice && this.getTotalAw()}
                                    </td>
                                    {/* <td style={{ textAlign: "center" }}>
                                    <b>
                                        {Dents &&
                                            parseInt(
                                            Dents.reduce((acc, num) => parseInt(acc) + num.AW, 0)
                                        )}
                                    </b>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <b>
                                        {Dents &&
                                            parseInt(
                                            Dents.reduce((acc, num) => parseInt(acc) + num.AW, 0)
                                            )}
                                        </b>
                                </td> */}
                                </tr>
                                <tr>
                                    <td colSpan={17} className="empty_col"></td>
                                </tr>
                                <tr className="extra_row_tfoot cz_bottom_footer">
                                    <td style={{ fontWeight: "bold", border: 'none' }}></td>
                                    {/* { this.props.viewType === 'TabView' && <td style={{ fontWeight: "bold",border:'none' }}></td>} */}
                                    {/* {
                                    this.props.viewType === 'TabView' ? 
                                    <>
                                        <td style={{ fontWeight: "bold",textAlign:'center' }}>
                                        <button
                                            style={{
                                            // padding:'5px',
                                            backgroundColor:'#F20000', 
                                            padding: "5px 10px",
                                            color : 'white',
                                            border: "none",
                                            borderRadius: "5px",
                                            fontSize: "16px",
                                            }}
                                            onClick = {this.handleDentsSaveA}
                                        >
                                            Save
                                        </button>
                                        </td>

                                        <td style={{ fontWeight: "bold", textAlign:'center'}}>
                                        <button
                                            style={{
                                            // padding:'5px',
                                            backgroundColor:'#F20000', 
                                            padding: "5px 10px",
                                            color : 'white',
                                            border: "none",
                                            borderRadius: "5px",
                                            fontSize: "16px",
                                            }}
                                            onClick = {this.handleDentsSaveB}
                                        >
                                            Save
                                        </button>
                                        </td>
                                    </> 
                                    : 
                                    <>
                                        <td style={{ fontWeight: "bold",border:'none' }}></td>
                                    </>
                                        
                                    } */}

                                    <td
                                        colSpan={this.props.is_extra_columns_visible ? partnerId == "demo-cz" ? 17 : 15 : partnerId == "demo-cz" ? 13 : 11}
                                        // colSpan={this.props.is_extra_columns_visible ? 14 : 10}
                                        style={dynamic_Table_Colors}
                                        className="text-right"
                                    >
                                        {this.lang('Preparation AW')}
                                    </td>
                                    <td className="empty_row"></td>
                                    <td
                                        colSpan='1'
                                        style={{
                                            color: `${["Axa", "Slavia", "Direct", "Audatex", "Allianz"].includes(insuranceName)
                                                ? ""
                                                : "red"
                                                }`,
                                            textAlign: "right",
                                            fontWeight: "normal",
                                            ...dynamic_Table_Colors
                                        }}
                                    >
                                        {ShowPrice &&
                                            (this.props.is_extra_columns_visible ?
                                                <div style={{ position: 'relative', width: '100%' }}>
                                                    <input
                                                        type="number"
                                                        style={{ width: '100%', border: 'none', outline: 'none', backgroundColor: "transparent", textAlign: "center", color: `${["Axa", "Slavia", "Direct", "Audatex", "Allianz"].includes(insuranceName) ? "" : "red"}` }}
                                                        // value={this.state.preparation}
                                                        value='0'
                                                        disabled={Authorized}
                                                        name="preparation"
                                                        onChange={(e) => this.handleFooterChange(e)}
                                                        min='0'
                                                    // width='100%'
                                                    />
                                                    {!data.Authorized &&
                                                        <>
                                                            <div className="button-table-arrow-position">
                                                                <button
                                                                    onClick={() => {
                                                                        const updatedValue = Math.max((parseInt(0) || 0) - 1, 0);
                                                                        this.handleFooterChange({ target: { name: 'preparation', value: updatedValue } });
                                                                    }}
                                                                    disabled={data.Authorized}
                                                                    className="decrement-button"
                                                                >
                                                                    -
                                                                </button>
                                                                <button
                                                                    onClick={() => {
                                                                        const updatedValue = (parseInt(0) || 0) + 1;
                                                                        this.handleFooterChange({ target: { name: 'preparation', value: updatedValue } });
                                                                    }}
                                                                    disabled={data.Authorized}
                                                                    className="increment-button"
                                                                >
                                                                    +
                                                                </button>
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                                :
                                                // this.state.preparation
                                                0)
                                        }

                                    </td>
                                </tr>
                                <tr className="extra_row_tfoot cz_bottom_footer">
                                    {!this.props.is_extra_columns_visible && <td style={{ fontWeight: "bold", border: 'none' }}></td>}
                                    {this.props.is_extra_columns_visible && <td style={{ fontWeight: "bold", border: 'none' }}></td>}
                                    <td colSpan={this.props.is_extra_columns_visible ? partnerId == "demo-cz" ? 17 : 15 : partnerId == "demo-cz" ? 13 : 11} className=""
                                        style={{ textAlign: "right", fontWeight: "normal" }}
                                    >
                                        {/* <td colSpan={this.props.is_extra_columns_visible ? 14 : 10} className="" */}
                                        {this.lang('Dismantling- and Assembly fee AW')}
                                    </td>
                                    <td className="empty_row"></td>
                                    <td
                                        style={{
                                            color: `${["Axa", "Slavia", "Direct", "Audatex", "Allianz"].includes(insuranceName)
                                                ? ""
                                                : "red"
                                                }`,
                                            textAlign: "right",
                                            fontWeight: "normal",
                                            ...dynamic_Table_Colors
                                        }}
                                    // colSpan='1'
                                    >
                                        {ShowPrice &&
                                            (this.props.is_extra_columns_visible ?
                                                <div style={{ position: 'relative', width: '100%' }}>
                                                    <input
                                                        type="number"
                                                        style={{ width: '100%', border: 'none', outline: 'none', textAlign: "center", color: `${["Axa", "Slavia", "Direct", "Audatex", "Allianz"].includes(insuranceName) ? "" : "red"}` }}
                                                        onChange={(e) => this.handleFooterChange(e)}
                                                        name="dismantling"
                                                        disabled={Authorized}
                                                        // value={this.state.dismantling}
                                                        value='0'
                                                        min='0'
                                                    // width='100%'
                                                    />
                                                    {!data.Authorized &&
                                                        <>
                                                            <div className="button-table-arrow-position">
                                                                <button
                                                                    onClick={() => {
                                                                        const updatedValue = Math.max((parseInt(0) || 0) - 1, 0);
                                                                        this.handleFooterChange({ target: { name: 'preparation', value: updatedValue } });
                                                                    }}
                                                                    disabled={data.Authorized}
                                                                    className="decrement-button"
                                                                >
                                                                    -
                                                                </button>
                                                                <button
                                                                    onClick={() => {
                                                                        const updatedValue = (parseInt(0) || 0) + 1;
                                                                        this.handleFooterChange({ target: { name: 'preparation', value: updatedValue } });
                                                                    }}
                                                                    disabled={data.Authorized}
                                                                    className="increment-button"
                                                                >
                                                                    +
                                                                </button>
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                                :
                                                // this.state.dismantling
                                                0)
                                        }
                                    </td>
                                    {/* <td style={{ fontWeight: "bold",border:'none' }}></td> */}
                                </tr>

                                {/* price/hr */}
                                {/* <tr>
                                    <td style={{ fontWeight: "bold",border:'none' }}></td>
                                    <td 
                                        colSpan={"8"}
                                        style={{ textAlign: "right", fontWeight:"normal"}}
                                        >
                                            {this.lang('Price/hr')}
                                    </td>
                                    <td colSpan='2' style={{textAlign: "center", fontWeight:"normal"}}>
                                    { this.props.is_extra_columns_visible  ? 
                                        <input 
                                        type="number"
                                        style={{width :'100%', border:'none', outline: 'none',  textAlign:"center"}}
                                        onChange={(e) => this.handleFooterChange(e)}
                                        name="PricePerHour"
                                        value={this.state.PricePerHour}
                                        // width='100%'
                                        /> :
                                        this.state.PricePerHour
                                    }
                                    </td>
                              </tr> */}
                                <tr className="cz_table_footer extra_row_tfoot cz_bottom_footer">
                                    <td style={dynamic_Table_Colors}></td>
                                    <td
                                        className="text-right bottom-left-border"
                                        colSpan={this.props.is_extra_columns_visible ? partnerId == "demo-cz" ? 17 : 15 : partnerId == "demo-cz" ? 13 : 11}
                                        // colSpan={this.props.is_extra_columns_visible ?  14 : 10 }
                                        id="print_table_bg_replace"
                                        // style={{ textAlign: "right", color: 'white', backgroundColor: '#00B38E' }}
                                        style={dynamic_Table_Colors}
                                    >
                                        {this.lang('Total Damage Cost')}
                                    </td>
                                    <td className="empty_row"></td>
                                    <td
                                        className="bottom-right-border"
                                        id="print_table_bg_value"
                                        colSpan='2'
                                        style={{
                                            color: `${["Axa", "Slavia", "Direct", "Audatex", "Allianz"].includes(insuranceName)
                                                ? ""
                                                : "red"
                                                }`,
                                            textAlign: 'right',
                                            fontWeight: "normal",
                                            fontWeight: "bold",
                                            color: 'white',
                                            minWidth: "150px",
                                            backgroundColor: '#00B38E',
                                            ...dynamic_Table_Colors
                                        }}
                                    >
                                        {(insuranceName !== 'Audatex' && ShowPrice) ? 'Kč ' : ''}
                                        {ShowPrice && data && this.getRepairCost(data, this.state.preparation, this.state.dismantling)}
                                    </td>
                                    {/* <td style={{ fontWeight: "bold",border:'none' }}></td> */}
                                </tr>
                            </tfoot>
                        </table>
                        {modal &&
                            // <Lightbox
                            //     reactModalStyle={{
                            //         overlay: { zI ndex: 100000000 },
                            //         content: {},
                            //     }}
                            //     mainSrc={
                            //         configuration.imagePath +
                            //         "/scanImages/" +
                            //         partnerId +
                            //         "/" +
                            //         vin +
                            //         "/" +
                            //         "Report_" + imgPartName + '_1.jpg'

                            //     }
                            //     onCloseRequest={() =>
                            //         this.setState({
                            //             modal: false,
                            //         })
                            //     }
                            //     onImageLoadError={(...events) => console.log(events)}
                            //     imageLoadErrorMessage={<img style={{ height: '100%', width: "100%" }} src={require("../../assets/img/brand/dashboard-error-logo.png")} />}
                            // />
                            <Lightbox
                                reactModalStyle={{
                                    overlay: { zIndex: 100000000 },
                                    content: {},
                                }}
                                mainSrc={
                                    this.state.filteredImages.length > 0
                                      ? `${this.state.filteredImages[this.state.currentImageIndex]}?t=${new Date().getTime()}` // Append timestamp
                                      : require("../../assets/img/brand/dashboard-error-logo.png")
                                  }
                                  imageCaption={this.state.filteredImages.length > 0 && this.lang(
                                    this.state.filteredImages[this.state.currentImageIndex]
                                      .split('/')
                                      .pop()
                                      .replace(/^Report_/, '')
                                      .replace(/_\d+\.jpg$/, '')
                                  )}
                                  nextSrc={
                                    `${this.state.filteredImages[
                                      (this.state.currentImageIndex + 1) % this.state.filteredImages.length
                                    ]}?t=${new Date().getTime()}`
                                  }
                                  prevSrc={
                                    `${this.state.filteredImages[
                                      (this.state.currentImageIndex +
                                        this.state.filteredImages.length -
                                        1) % this.state.filteredImages.length
                                    ]}?t=${new Date().getTime()}`
                                  }
                                onCloseRequest={() => this.setState({ modal: false })}
                                onMovePrevRequest={() =>
                                    this.setState({
                                        currentImageIndex:
                                            (this.state.currentImageIndex +
                                                this.state.filteredImages.length -
                                                1) %
                                            this.state.filteredImages.length,
                                    })
                                }
                                onMoveNextRequest={() =>
                                    this.setState({
                                        currentImageIndex:
                                            (this.state.currentImageIndex + 1) %
                                            this.state.filteredImages.length,
                                    })
                                }
                                onImageLoadError={(...events) => console.log(events)}
                                imageLoadErrorMessage={
                                    <img
                                        style={{ height: "100%", width: "100%" }}
                                        src={require("../../assets/img/brand/dashboard-error-logo.png")}
                                    />
                                }
                            />
                        }
                    </div>
                </div>
            </div>
        );
    }
}
const mapDispatchtoProps = (dispatch) => {
    return {
        getSelectedPartnerId: (show) => dispatch(getSelectedPartnerId(show)),
    };
};
const mapStateToProps = (props) => {
    return {
        lang: props.lang,
        toggleReportDamageImage: props.toggleReportDamageImage
    };
};
export default connect(mapStateToProps, mapDispatchtoProps)(CZPriceTable);
